;(function(window, document, undefined) {
  'use strict';
var Deferred = (function(){
  Promise.settle = function(promisesArr){
    var reflectedArr = promisesArr.map(function(promise){
      return promise.then(function(successResult){
        return {
          result: successResult,
          status: 'resolved'
        };
      },function(errorResult){
        return {
          result: errorResult,
          status: 'rejected'
        };
      });
    });
    return Promise.all(reflectedArr);
  };
  
  function Deferred(){
    var def = this;
    /**
     * @instance
     * @memberof Flybits.Deferred
     * @member {external:Promise} promise Instance of an ES6 Promise to be fulfilled.
     */
    this.promise = new Promise(function(resolve,reject){
      /**
       * @instance
       * @memberof Flybits.Deferred
       * @member {function} resolve Callback to be invoked when the asychronous task that initiated the promise is successfully completed.
       */
      def.resolve = resolve;
      /**
       * @instance
       * @memberof Flybits.Deferred
       * @member {function} reject Callback to be invoked when the asychronous task that initiated the promise has failed to complete successfully.
       */
      def.reject = reject;
    });

    this.then = this.promise.then.bind(this.promise);
    this.catch = this.promise.catch.bind(this.promise);
  }

  return Deferred;
})();

var Validation = (function(){
  function Validation(){
    this.state = true;
    this.errors = [];

    this.stacktrace = "";

    this.setStackTrace();
  }

  Validation.prototype = {
    addError: function(header,message,detailsObj){
      this.state = false;
      var retObj = {
        header: header,
        message: message
      };
      if(detailsObj){
        retObj.context = detailsObj.context;
        retObj.code = detailsObj.code;
        retObj.serverCode = detailsObj.serverCode;
      }
      this.errors.push(retObj);

      return this;
    },
    firstError: function(){
      if(this.errors.length > 0){
        return this.errors[0];
      }
      return null;
    },
    setStackTrace: function(){
      var flyError = new Error();
      flyError.name = "FlybitsError";
      this.stacktrace = flyError.stack;
      if(this.stacktrace){
        this.stacktrace = this.stacktrace.split('\n').filter(function(str){
          return str.indexOf('Validation') < 0;
        }).join('\n');
      }
      return this;
    }
  };

  Validation.prototype.type = Validation.type = {};
  Validation.prototype.type.MALFORMED = Validation.type.MALFORMED = 1000;
  Validation.prototype.type.INVALIDARG = Validation.type.INVALIDARG = 1001;
  Validation.prototype.type.MISSINGARG = Validation.type.MISSINGARG = 1002;
  Validation.prototype.type.NOTFOUND = Validation.type.NOTFOUND = 1003;
  Validation.prototype.type.CONNECTIONERROR = Validation.type.CONNECTIONERROR = 1004;
  Validation.prototype.type.UNAUTHENTICATED = Validation.type.UNAUTHENTICATED = 1005;
  Validation.prototype.type.RETRIEVALERROR = Validation.type.RETRIEVALERROR = 1006;
  Validation.prototype.type.NOTSUPPORTED = Validation.type.NOTSUPPORTED = 1007;
  Validation.prototype.type.UNEXPECTED = Validation.type.UNEXPECTED = 1008;

  return Validation;
})();

var DemoPlugin = (function(){
  function DemoPlugin(typeID, opts){
    this.TYPEID = typeID;
    Flybits.context.ContextPlugin.call(this,opts);
    this.lastObj = null;
  };

  DemoPlugin.prototype = Object.create(Flybits.context.ContextPlugin.prototype);
  DemoPlugin.prototype.constructor = DemoPlugin;

  DemoPlugin.prototype.TYPEID = 'ctx.demo.plugin';

  DemoPlugin.prototype.isSupported = DemoPlugin.isSupported = function(){
    return Promise.resolve();
  };

  DemoPlugin.prototype.getState = DemoPlugin.getState = function(){
    return Promise.resolve(this.lastObj);
  };

  DemoPlugin.prototype.setState =  function(obj){
    this.lastObj = obj;
    return Flybits.context.ContextPlugin.prototype.setState.call(this, obj);
  };

  return DemoPlugin;
})();
var NotificationManagerFactory = (function(){
  var Manager = (function(){
    function Manager(){
      this.notifications = [];
    }

    Manager.prototype.showMessage = function(notification){
      notification.sentAt = new Date();
      this.notifications.push(notification);
    };

    return Manager;
  })();

  var SWManager = (function(){
    function SWManager(){
      Manager.call(this);
      this.registration;
      
      var man = this;
      navigator.serviceWorker.register('sw.js');
      this.ready = navigator.serviceWorker.ready;
      this.ready.then(function(registration){
        man.registration = registration;
      });
    }
    SWManager.prototype = Object.create(Manager.prototype);
    SWManager.prototype.constructor = SWManager;

    SWManager.prototype.showMessage = function(notification){
      var opts = {
        icon: notification.iconURL
      };
      if(notification.body){
        opts.body = notification.body;
      }
      if(notification.imgURL){
        opts.image = notification.imgURL;
      }
      this.registration.showNotification(notification.title,opts);
      Manager.prototype.showMessage.call(this, notification);
    }

    return SWManager;
  })();

  var IOSManager = (function(){
    function IOSManager(){
      Manager.call(this);
    }
    IOSManager.prototype = Object.create(Manager.prototype);
    IOSManager.prototype.constructor = IOSManager;

    IOSManager.prototype.showMessage = function(notification){
      App.evt.emit(App.actions.IOSPUSH,notification);
      Manager.prototype.showMessage.call(this, notification);
    };

    return IOSManager;
  })();

  var DesktopManager = (function(){
    function DesktopManager(){
      Manager.call(this);
    }
    DesktopManager.prototype = Object.create(Manager.prototype);
    DesktopManager.prototype.constructor = DesktopManager;

    DesktopManager.prototype.showMessage = function(notification){
      var opts = {
        icon: notification.iconURL
      };
      if(notification.body){
        opts.body = notification.body;
      }
      if(notification.imgURL){
        opts.image = notification.imgURL;
      }
      var nativeNotification = new Notification(notification.title,opts);
      Manager.prototype.showMessage.call(this, notification);
    };
  })();

  var NotificationManagerFactory = {
    getManager: function(){
      if(navigator.hasOwnProperty('serviceWorker') && window.ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification')){
        var def = new Flybits.Deferred();
        var man;
        NotificationManagerFactory.requestPermission().then(function(){
          man = new SWManager();
          return man.ready; 
        }).then(function(){
          def.resolve(man);
        }).catch(function(e){
          console.log('> manager init failed');
          def.resolve(new IOSManager());
        });
        
        return def.promise;
      } else{
        return Promise.resolve(new IOSManager());
      }
    },
    requestPermission: function(){
      var def = new Flybits.Deferred();

      window.Notification.requestPermission(function(result){
        if(result === 'granted'){
          def.resolve();
        } else{
          def.reject();
        }
      });

      return def.promise;
    }
  };

  return NotificationManagerFactory;
})();
var ContentNotification = window.ContentNotification = (function(){
  function ContentNotification(contentInstanceID, opts){
    opts = opts || {};
    this.id = contentInstanceID;
    this.title = opts.title;
    this.body = opts.body;
    this.imgURL = opts.imgURL;
    this.deepLink = opts.deeplink;
    this.linkType  = opts.linkType;
    this.iconURL = opts.headerIcon || 'images/logoIcon_white.svg';
    this.appTitle = opts.noteHeader;
    this.createdAt = new Date();
    this.sentAt;
  };

  ContentNotification.prototype = {
    fromCI: function(ci){
      console.log('> omg', ci);
      
      return this;
    }
  };

  return ContentNotification;
})();
var Theme = (function(){
  function Theme(serverObj, groupName){
    this.id = App.util.Obj.guid();
    this.groupName = groupName;
    this.mode = null;
    this.splashURL = null;
    this.appscreenURL = null;
    this.widgetIconURL = null;
    this.primaryColor = null;
    this.secondaryColor = null;
    this.tertiaryColor = null;
    this.fgColor = null;
    this.hash = null;
    this.fineGrainColor = {
      feedBG: null,
      pillsBG: null,
      tabbarBG: null,
      tabbarActiveBG: null,
      widgetBG: null,
      buttonBG: null
    };
    this.pillsEnabled = false;
    this.pills = [];
    this.tileStyle = {
      borderColor: '#e5e5e5',
      borderRadius: 4,
      enableShadow: true,
      sideMargin: 10
    };
    this.enableHeaderIcon = false;

    if(serverObj){
      this.fromJSON(serverObj);
    }
  };

  Theme.prototype = {
    fromJSON: function(serverObj){
      this.hash = App.util.Obj.hash(JSON.stringify(serverObj));
      this.id = serverObj.id;
      this.mode = serverObj.mode;
      this.splashURL = serverObj.splashURL;
      this.appscreenURL = serverObj.appscreenURL;
      this.widgetIconURL = serverObj.widgetIconURL;
      this.primaryColor = serverObj.primaryColor;
      this.secondaryColor = serverObj.secondaryColor;
      this.tertiaryColor = serverObj.tertiaryColor;
      this.fgColor = serverObj.fgColor;

      this.fineGrainColor.feedBG = serverObj.fineGrainColor?serverObj.fineGrainColor.feedBG:null;
      this.fineGrainColor.pillsBG = serverObj.fineGrainColor?serverObj.fineGrainColor.pillsBG:null;
      this.fineGrainColor.tabbarBG = serverObj.fineGrainColor?serverObj.fineGrainColor.tabbarBG:null;
      this.fineGrainColor.tabbarActiveBG = serverObj.fineGrainColor?serverObj.fineGrainColor.tabbarActiveBG:null;
      this.fineGrainColor.widgetBG = serverObj.fineGrainColor?serverObj.fineGrainColor.widgetBG:null;
      this.fineGrainColor.buttonBG = serverObj.fineGrainColor?serverObj.fineGrainColor.buttonBG:null;

      this.pillsEnabled = serverObj.hasOwnProperty('pillsEnabled')?serverObj.pillsEnabled:true;
      if(serverObj.pills){
        this.pills = serverObj.pills;
      }

      this.tileStyle.borderColor = serverObj.tileStyle?serverObj.tileStyle.borderColor:'#e5e5e5';
      this.tileStyle.borderRadius = serverObj.tileStyle?serverObj.tileStyle.borderRadius:4;
      this.tileStyle.enableShadow = serverObj.tileStyle?serverObj.tileStyle.enableShadow:true;
      this.tileStyle.sideMargin = serverObj.tileStyle?serverObj.tileStyle.sideMargin:10;
      
      this.enableHeaderIcon = serverObj.enableHeaderIcon;

      if(App.util.Browser.getURLParam('web')){
        this.mode = Theme.FULLSCREEN;
      }

      return this;
    },
    toJSON: function(){
      return {
        groupName: this.groupName,
        keyProperty: 'id',
        payload: {
          id: this.id,
          mode: this.mode,
          splashURL: this.splashURL,
          appscreenURL: this.appscreenURL,
          widgetIconURL: this.widgetIconURL,
          primaryColor: this.primaryColor,
          secondaryColor: this.secondaryColor,
          tertiaryColor: this.tertiaryColor,
          fgColor: this.fgColor,
          fineGrainColor: this.fineGrainColor,
          pillsEnabled: this.pillsEnabled,
          pills: this.pills,
          tileStyle: this.tileStyle,
          enableHeaderIcon: this.enableHeaderIcon
        }
      };
    }
  };

  Theme.FULLSCREEN = Theme.prototype.FULLSCREEN = 'fullscreen';
  Theme.EMBEDDED = Theme.prototype.EMBEDDED = 'embedded';
  Theme.WIDGET = Theme.prototype.WIDGET = 'widget';

  return Theme;
})();
var Profile = (function(){
  function Profile(serverObj){
    this.id = App.util.Obj.guid();
    this.name = '';
    this.description = '';
    this.color = '';
    this.iconURL = '';
    this.tmpState = null;
    this.ctxs = [];
    this.hash = null;
    this.authType = 'anonymous';
    this.isDisabled = false;
    this.auth = {
      token: ''
    };

    if(serverObj){
      this.fromJSON(serverObj);
    }
  };

  Profile.prototype = {
    saveState: function(){
      this.tmpState = this.toJSON();
    },
    restoreState: function(){
      if(this.tmpState){
        this.fromJSON(this.tmpState);
      }
    },
    fromJSON: function(serverObj){
      this.hash = App.util.Obj.hash(JSON.stringify(serverObj));
      this.id = serverObj.id;
      this.name = serverObj.name;
      this.description = serverObj.desc;
      this.iconURL = serverObj.iconURL;
      this.color = serverObj.color;
      this.ctxs = serverObj.ctxs;

      if(serverObj.authType){
        this.authType = serverObj.authType;
      }
      if(serverObj.auth){
        this.auth = serverObj.auth;
      }
      if(serverObj.hasOwnProperty('isDisabled')){
        this.isDisabled = serverObj.isDisabled;
      }
    },
    toJSON: function(){
      var retObj = {
        id: this.id,
        name: this.name,
        desc: this.description,
        iconURL: this.iconURL,
        color: this.color,
        ctxs: this.ctxs,
        authType: this.authType,
        auth: this.auth,
        isDisabled: this.isDisabled
      };

      return retObj;
    }
  };

  Profile.auth = Profile.prototype.auth = {
    OIDC: 'oidc',
    OKTA: 'okta',
    JWT: 'jwt',
    ANONYMOUS: 'anonymous',
    FLYBITS: 'flybits'
  };

  return Profile;
})();
var InteractionPlugin = (function(){
  function InteractionPlugin(opts){
    this.TYPEID = App.cfg.ctx?App.cfg.ctx.CONTENTINTERACTION:'';
    Flybits.context.ContextPlugin.call(this,opts);
  };

  InteractionPlugin.prototype = Object.create(Flybits.context.ContextPlugin.prototype);
  InteractionPlugin.prototype.constructor = InteractionPlugin;

  InteractionPlugin.prototype.TYPEID = 'ctx.demo.interaction';

  InteractionPlugin.prototype.isSupported = InteractionPlugin.isSupported = function(){
    return Promise.resolve();
  };

  InteractionPlugin.prototype.getState = InteractionPlugin.getState = function(){
    return Promise.resolve();
  };

  return InteractionPlugin;
})();
var OidcIDP = (function(){
  function OidcIDP(opts){
    Flybits.idp.IDP.call(this, opts);
    this.idToken = opts.idToken
  };

  OidcIDP.prototype = Object.create(Flybits.idp.IDP.prototype);
  OidcIDP.prototype.constructor = OidcIDP;

  OidcIDP.prototype.getURL = function(){
    return Flybits.cfg.HOST + '/sso/auth/oidc';
  };

  OidcIDP.prototype.getPayload = function(){
    var validation = new Flybits.Validation();
    var retObj = {
      provider: 'oidc',
      idToken: this.idToken
    };

    if(!this.idToken){
      validation.addError('Missing ID Token','No OIDC ID Token was supplied',{
        code: Validation.type.MISSINGARG,
        context: 'idToken'
      });
    }

    if(this.projectID){
      retObj.projectId = this.projectID;
    }

    if(!validation.state){
      throw validation;
    }

    return retObj;
  };

  return OidcIDP;
})();
var ContentAnalytics = (function(){
  function ContentAnalytics(opts){
    Flybits.context.ContextPlugin.call(this,opts);
  };

  ContentAnalytics.prototype = Object.create(Flybits.context.ContextPlugin.prototype);
  ContentAnalytics.prototype.constructor = ContentAnalytics;

  ContentAnalytics.prototype.TYPEID = 'ctx.flybits.contentAnalytics';

  ContentAnalytics.prototype.isSupported = ContentAnalytics.isSupported = function(){
    return Promise.resolve();
  };

  ContentAnalytics.prototype.getState = ContentAnalytics.getState = function(){
    return Promise.resolve();
  };

  return ContentAnalytics;
})();
var LoadingView = Vue.extend({
  template:'#view-loading',
});
Vue.component('loading-view',LoadingView);
var LoaderBar = Vue.extend({
  template:'#loader-bar',
});
Vue.component('loader-bar',LoaderBar);

var HeaderBar = Vue.extend({
  template:'#header-bar',
  props: {
    headerTitle: {
      type: String
    },
    backMode: {
      type: Boolean,
      default: false
    },
    showLogo: {
      type: Boolean,
      default: true
    },
    themeColor: {
      type: String,
      default: '#005692'
    },
    fontColor: {
      type: String,
      default: '#000000'
    },
    disableBrand: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showBrand: function(){
      return !this.disableBrand && !App.settings.theme.enableHeaderIcon;
    },
    showIcon: function(){
      return App.settings.theme.enableHeaderIcon;
    },
    iconURL: function(){
      return App.settings.theme.widgetIconURL;
    }
  },
  methods:{
    conAction: function(){
      if(this.backMode){
        App.router.back();
      } else{
        App.evt.emit(App.actions.MAIN_MENU,true);
      }
    }
  },
});
Vue.component('header-bar',HeaderBar);

var SideBar = Vue.extend({
  template:'#side-bar',
  props: ['user', 'opts', 'debug', 'pollEnabled', 'version', 'profile','disableBrand'],
  data: function(){
    return {
      isOpen: false,
      startX: 0,
      startY: 0,
      startScrollY: 0,
      currentX: 0,
      currentY: 0,
      translateX: 0,
      isTouching: false,
      isUserOptsOpen: false,
      jwt: '',
      jwtClip: null
    };
  },
  watch: {
    isOpen: function(newVal,oldVal){
      var view = this;
      if(newVal){
        setTimeout(function(){
          $('html,body').on('click.sidemenu touchstart.sidemenu',function(e){
            var menuShell = $(e.target).closest('.side-bar .contents');
            if(menuShell.length <= 0){
              view.isOpen = false;
            }
          });
        },100);

        this.jwt = Flybits.Session.userToken;
      } else{
        $('html,body').off('.sidemenu');
        this.$elScroller.scrollTop = 0;
        view.isUserOptsOpen = false;
      }
    },
    isUserOptsOpen: function(newVal, oldVal){
      if(newVal){
        this.jwtClip = new ClipboardJS('.version-label .copy.btn');
        this.jwtClip.on('success', function(e){
          App.toast('Copied');
        });
      } else{
        this.jwtClip.destroy();
      }
    }
  },
  methods: {
    appInit: function(){
      var view = this;

      App.evt.on(App.actions.MAIN_MENU,function(bool){
        if(bool){
          view.isOpen = true;
        } else{
          view.isOpen = false;
        }
      });
    },
    clearCIViewed: function(){
      var view = this;
      App.store.prop.ciViewed.clear();
      App.toast.info('view states cleared');

      setTimeout(function(){
        view.isOpen = false;
      },100);
    },
    openChat: function(){
      App.evt.emit(App.actions.CONVERSE);
      var view = this;
      setTimeout(function(){
        view.isOpen = false;
      },100);
    },
    toggleUserOpts: function(){
      this.isUserOptsOpen = !this.isUserOptsOpen;
    },
    togglePolling: function(){
      if(this.pollEnabled){
        App.stopPoll();
      } else{
        App.startPoll();
      }
    },
    gotoCTX: function(){
      var view = this;
      App.router.push('context');
      setTimeout(function(){
        view.isOpen = false;
      },100);
    },
    changeProfile: function(){
      var view = this;
      App.evt.emit(App.actions.LOADING,true);
      App.stopPoll();
      App.store.flushAll();
      Flybits.context.Manager.unregisterAll();

      App.login().then(function(){
        App.vm.sessionUser = Flybits.Session.user;
        App.router.push('seed');
      }).catch(function(){}).then(function(){
        view.isOpen = false;
        App.evt.emit(App.actions.LOADING, false);
      });
    },
    resetUser: function(){
      App.evt.emit(App.actions.LOADING,true);
      App.clearSession();
      Flybits.Session.disconnect().catch(function(){}).then(function(){
        window.location.reload();
      });
    },
    updatePosition: function(){
      if(!this.isTouching){
        return;
      }
      requestAnimationFrame(this.updatePosition);

      this.translateX = Math.min(0, this.currentX - this.startX);
      this.$elContent.style.transform = "translateX("+this.translateX+"px)";
      this.$elScroller.scrollTop = this.startScrollY - (this.currentY - this.startY);
    },
    touchStart: function(e){
      this.startX = e.pageX || e.touches[0].pageX;
      this.startY = e.pageY || e.touches[0].pageY;
      this.startScrollY = this.$elScroller.scrollTop;
      this.currentX = this.startX;
      this.currentY = this.startY;
      this.isTouching = true;
      this.$elContent.style.transition = "none";

      requestAnimationFrame(this.updatePosition);
    },
    touchMove: function(e){
      this.currentX = e.pageX || e.touches[0].pageX;
      this.currentY = e.pageY || e.touches[0].pageY;
      this.translateX = Math.min(0, this.currentX - this.startX);

      e.preventDefault();
      e.stopPropagation();
      return false;
    },
    touchEnd: function(e){
      this.isTouching = false;
      this.translateX = Math.min(0, this.currentX - this.startX);
      this.$elContent.style.transform = '';
      this.$elContent.style.transition = '';

      var bounds = this.$elContent.getBoundingClientRect();
      if(bounds.left <= bounds.width/-2){
        this.isOpen = false;
      }
    }
  },
  mounted: function(){
    var view = this;
    setTimeout(function(){
      App.ready.then(function(){
        view.appInit();
      });
    },1);
    this.$elContent = $(this.$el).find('.contents')[0];
    this.$elScroller = $(this.$el).find('.scroll-wrap')[0];
    $(this.$elContent).on('touchstart',view.touchStart);
    $(this.$elContent).on('touchmove',view.touchMove);
    $(this.$elContent).on('touchend',view.touchEnd);
  }
});
Vue.component('side-bar',SideBar);

var CardPlaceholder = Vue.extend({
  template:'#card-placeholder',
  data: function(){
    return {
      block: 0
    };
  },
  methods: {
    /** inclusive */
    getRandomInt: function(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    } 
  },
  mounted: function(){
    this.block = this.getRandomInt(0,3);
  }
});
Vue.component('card-placeholder',CardPlaceholder);

var CardBase = Vue.extend({
  template:'#card-base',
  props: {
    content: {
      type: Object
    }
  },
  watch: {
    'content.data': function(){
      this.setData();
    }
  },
  methods: {
    setData: function(){
      
    }
  },
  mounted: function(){
    if(this.content && this.content.data){
      this.setData();
    }
  }
});
Vue.component('card-base',CardBase);

var CardCta = Vue.extend({
  template:'#card-cta',
});
Vue.component('card-cta',CardCta);

var CardText = CardBase.extend({
  template:'#card-text',
  data: function(){
    return {
      root: {
        title: {},
        body: {}
      }
    };
  },
  computed: {
    themeColor: function(){
      return App.vm.currentProfile.color || "#005692";
    }
  },
  methods: {
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.root.title = App.util.Obj.toValueObj(obj,'title');
        view.root.body = App.util.Obj.toValueObj(obj,'body'); 
      });
    }
  },
});
Vue.component('card-text',CardText);

var CardVideo = CardBase.extend({
  template:'#card-video',
  data: function(){
    var retObj = {
      videos: []
    };

    return retObj;
  },
  computed: {
    isMultiple: function(){
      return this.proxyVideos.length > 1;
    },
    proxyVideos: function(){
      return this.videos.slice(0, 3);
    }
  },
  methods: {
    drillDown: function(){
      App.router.push('/videos/'+this.content.id);
    },
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.videos = obj.video.data;
      });
    },
    videoPlay: function(vid){
      var ctx = {};
      if(App.ctx.interaction){
        ctx['isViewed.'+this.content.id] = true;
        App.ctx.interaction.setState(ctx);
      }

      if(App.ctx.contentAnalytics){
        var contentCTX = {};
        contentCTX['viewed.'+this.content.id] = true;
        App.ctx.contentAnalytics.setState(contentCTX);
      }
    }
  },
});
Vue.component('card-video',CardVideo);

var YtVid = Vue.extend({
  template:'#yt-vid',
  props: {
    rawUrl: {
      type: String
    }
  },
  data: function(){
    return {
      playMode: false,
    };
  },
  computed: {
    vId: function(){
      if(this.rawUrl){
        return App.util.Api.parseYoutubeID(this.rawUrl);
      }
      return;
    },
    thumbnailUrl: function(){
      if(this.vId){
        return 'https://img.youtube.com/vi/'+this.vId+'/maxresdefault.jpg';
      }
      return;
    },
    embedUrl: function(){
      if(this.vId){
        return 'https://www.youtube.com/embed/'+this.vId+'?rel=0&autoplay=1';
      }
      return;
    }
  },
  methods: {
    playVideo: function(){
      this.playMode = true;
      this.$emit('play');
    }
  }
});
Vue.component('yt-vid',YtVid);

var CardArticle = CardBase.extend({
  template:'#card-article',
  data: function(){
    var retObj = {
      articles: []
    };

    return retObj;
  },
  computed: {
    isMultiple: function(){
      return this.articles.length > 1;
    },
  },
  methods: {
    toValueObj: function(rootLocaleObj, propKey){
      return App.util.Obj.toValueObj(rootLocaleObj, propKey);
    },
    openArticle: function(url){
      if(App.ctx.contentAnalytics){
        var contentCTX = {};
        contentCTX['engaged.'+this.content.id] = true;
        App.ctx.contentAnalytics.setState(contentCTX);
      }
      
      if(url){
        App.openLink(url);
      }
    },
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.articles = obj.articles.data;
      });
    }
  },
});
Vue.component('card-article',CardArticle);

var CardEvent = CardBase.extend({
  template:'#card-event',
  data: function(){
    return {
      root: {
        title: {},
        location: {},
        address: {},
        description: {},
        registerURL: '',
        bannerURL: '',
        dateISO: '',
      }
    }
  },
  computed: {
    dateStr: function(){
      if(!this.root.dateISO || this.root.dateISO === ''){
        return '';
      }
      var d = new Date(this.root.dateISO);

      return d.getMonthName() + ' ' +
             d.getDate() + ', ' +
             d.getFullYear() + ' - ' +
             App.util.Obj.zero2Pad(d.getHours()) + ':' + 
             App.util.Obj.zero2Pad(d.getMinutes());
    } 
  },
  methods: {
    drillDown: function(){
      if(App.ctx.interaction){
        var ctx = {};
        ctx['isEngaged.'+this.content.id] = true
        App.ctx.interaction.setState(ctx);
      }
      if(App.ctx.contentAnalytics){
        var contentCTX = {};
        contentCTX['engaged.'+this.content.id] = true;
        App.ctx.contentAnalytics.setState(contentCTX);
      }
      App.router.push({
        name: 'event',
        params: {id:this.content.id}
      });
    },
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.root.title = App.util.Obj.toValueObj(obj,'title');
        view.root.description = App.util.Obj.toValueObj(obj,'description');
        view.root.location = App.util.Obj.toValueObj(obj,'location');
        view.root.address = App.util.Obj.toValueObj(obj,'address');
        view.root.bannerURL = obj.img;
        view.root.registerURL = obj.registerURL;
        view.root.dateISO = obj.date;
      });
    }
  },
});
Vue.component('card-event',CardEvent);

var LocalizedText = (function(){
  var resolveValue = function(localeObj,key){
    var localeKeys = Object.keys(localeObj);
    return localeObj[key] || localeObj['en'] || localeObj[localeKeys[0]];
  };

  return Vue.extend({
    template:'#localized-text',
    props: {
      localeObj: {
        type: Object,
        default: function(){
          return {
            en: ''
          };
        }
      }
    },
    computed: {
      localizedStr: function(){
        return resolveValue(this.localeObj);
      }
    }
  });
})();
Vue.component('localized-text',LocalizedText);

var LoadingCanvas = Vue.extend({
  template:'#loading-canvas',
});
Vue.component('loading-canvas',LoadingCanvas);

var NotificationCenter = (function(){
  
  return Vue.extend({
    template:'#notification-center',
    data: function(){
      return {
        notification: {},
        isVisible: false,
        dragger: null,
        isDragging: false,
      };
    },
    computed: {
      isLocationLink: function(){
        return this.notification.linkType === 'Location';
      },
      isChatLink: function(){
        return this.notification.linkType === 'Chat Topic';
      },
      isURL: function(){
        return this.notification.linkType === 'URL';
      },
      isContentLink: function(){
        return this.notification.linkType === 'Content Page';
      },
      appTitle: function(){
        return this.notification.appTitle || '';
      }
    },
    methods: {
      gMapDirURL: function(address){
        if(address){
          return 'https://maps.google.com/maps/dir/?api=1&destination='+Flybits.util.Api.htmlEncode(address);
        }
        return '';
      },
      showNotification: function(notification){
        var view = this;
        this.isVisible = false;
        setTimeout(function(){
          view.notification = notification;
          Vue.nextTick(function(){
            view.isVisible = true;
            view.dragger = new MickDragger(view.$refs.notification);
            view.dragger.on(MickDragger.event.THRESHOLD, function(){
              console.log('> notified');
              view.dismiss();
            });
            view.dragger.on(MickDragger.event.DRAG, function(bool){
              if(!bool){
                setTimeout(function(){
                  view.isDragging = false;
                },300);
              } else{
                view.isDragging = true;
              }
            });
          });
        },150);
      },
      dismiss: function(e){
        console.log('> dismiss');
        this.isVisible = false;
        
        if(e){
          e.preventDefault();
          e.stopPropagation();
        }
        return false;
      },
      trigger: function(){
        if(this.isDragging){
          return false;
        }
        this.isVisible = false
        console.log('> clickity');
        
        if(App.ctx.contentAnalytics && this.notification.id){
          var contentCTX = {};
          contentCTX['engaged.'+this.notification.id] = true;
          App.ctx.contentAnalytics.setState(contentCTX);
        }

        if(this.isChatLink){
          App.evt.emit(App.actions.CONVERSE, {
            header: this.notification.title,
            body: this.notification.body,
            ctaLink: this.notification.deepLink
          });
        } else if(this.isLocationLink){
          App.openLink(this.gMapDirURL(this.notification.deepLink))
        } else if(this.isURL){
          App.openLink(this.notification.deepLink);
        } else if(this.isContentLink && this.notification.deepLink){
          App.gotoPageRoute(this.notification.deepLink);
        }

      }
    },
    mounted: function(){
      var view = this;
      setTimeout(function(){
        App.evt.on(App.actions.IOSPUSH, function(notification){
          view.showNotification(notification);
        });
      },100);
    }
  });
})();
Vue.component('notification-center',NotificationCenter);

var CtxvalueList = Vue.extend({
  template:'#ctxvalue-list',
  props: {
    ctxs: Array,
    fontColor: {
      type: String,
      default: '#1162A4'
    }
  },
  methods: {
    getValues: function(ctxValues){
      return Object.keys(ctxValues.values).map(function(key){
        return {
          key: key,
          value: ctxValues.values[key]
        };
      });
    },
  }
});
Vue.component('ctxvalue-list',CtxvalueList);

var CardActionable = CardBase.extend({
  template:'#card-actionable',
  data: function(){
    return {
      root: {
        header: '',
        body: '',
        icon: '',
        ctaLabel: '',
        ctaType: '',
        ctaLink: '',
        ctaColor: ''
      }
    };
  },
  computed: {
    isLocationLink: function(){
      return this.root.ctaType === 'Location';
    },
    isChatLink: function(){
      return this.root.ctaType === 'Chat Topic';
    },
    isURL: function(){
      return this.root.ctaType === 'URL';
    },
    actionStyle: function(){
      var style = {};
      if(this.root.ctaColor){
        style.backgroundColor = this.root.ctaColor;
        style.color = App.util.Obj.getContrastYIQ(this.root.ctaColor);
      }

      return style;
    }
  },
  methods: {
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.root.header = obj.header;
        view.root.body = obj.body;
        view.root.icon = obj.icon;
        view.root.ctaLabel = obj.ctaLabel;
        view.root.ctaType = obj.linkType;
        view.root.ctaLink = obj.deeplink;
        view.root.ctaColor = obj.ctaColor;
      });
    },
    triggerAction: function(){
      console.log('> trigger');
      if(App.ctx.interaction){
        var ctx = {};
        ctx['isEngaged.'+this.content.id] = true
        App.ctx.interaction.setState(ctx);
      }
      if(App.ctx.contentAnalytics){
        var contentCTX = {};
        contentCTX['engaged.'+this.content.id] = true;
        App.ctx.contentAnalytics.setState(contentCTX);
      }

      if(this.isChatLink){
        App.evt.emit(App.actions.CONVERSE, this.root);
      } else if(this.isLocationLink){
        App.openLink(this.gMapDirURL(this.root.ctaLink));
      } else if(this.isURL){
        App.openLink(this.root.ctaLink);
      }
    },
    gMapDirURL: function(address){
      if(address){
        return 'https://maps.google.com/maps/dir/?api=1&destination='+Flybits.util.Api.htmlEncode(address);
      }
      return '';
    },
  }
});
Vue.component('card-actionable',CardActionable);

var Hal9000 = (function(){

  var bot = {
    match: function(searchTarget, key){
      if(key instanceof Array){
        var result = true;
        for(var i = 0 ; i < key.length; i++){
          result = result && searchTarget.indexOf(key[i]) > -1;
        }
        return result;
      }

      return searchTarget.indexOf(key) > -1;
    }
  };

  var Message = (function(){
    function Message(opts){
      this.body = opts.body;
      this.sender = opts.sender || this.ME;
    };

    Message.ME = Message.prototype.ME = 'me';
    return Message;
  })();

  var State = (function(){
    function State(){
      this.id = StateManager.state.NEUTRAL;
    }

    State.prototype = {
      getStateMsg: function(){
        return;
      },
      hasNextState: function(){
        return false;
      },
      needsResponse: function(){
        return true;
      },
      getNextState: function(userMsg){
        return State;
      }
    };

    return State;
  })();

  var GreetingState = (function(){
    function GreetingState(seedMsg){
      State.call(this);
      this.id = StateManager.state.GREETING;
      this.seedMsg = seedMsg;
    }
    GreetingState.prototype = Object.create(State.prototype);
    GreetingState.prototype.constructor = GreetingState;

    GreetingState.prototype.getStateMsg = function(){
      return this.seedMsg || 'Hello there, how may I help you?';
    };
    
    GreetingState.prototype.needsResponse = function(){
      return false;
    };

    GreetingState.prototype.getNextState = function(){
      return new AwaitState();
    };

    return GreetingState;
  })();

  var AwaitState = (function(){
    function AwaitState(){
      State.call(this);
      this.id = StateManager.state.AWAIT;
    }
    AwaitState.prototype = Object.create(State.prototype);
    AwaitState.prototype.constructor = AwaitState;

    AwaitState.prototype.getStateMsg = function(){
      return;
    };

    AwaitState.prototype.needsResponse = function(){
      return true;
    };

    AwaitState.prototype.getNextState = function(usrMsg){
      var body = usrMsg.body.toLowerCase();
      if(bot.match(body,'balance')){
        return new OutputState(['Your current account balance is $10,000.','Is there anything else I can help you with?']);
      } else if(bot.match(body,['how much','trip']) && (bot.match(body,'spent') || bot.match(body,'spend'))){
        var amt = App.util.Obj.randomInt(1000,10000).toLocaleString();
        return new OutputState(['You spent $'+amt+' on your trip.','Is there anything else I can help you with?']);
      } else if(bot.match(body,['how much', 'shop']) && (bot.match(body,'spent') || bot.match(body,'spend'))){
        var amt = App.util.Obj.randomInt(1000,10000).toLocaleString();
        return new OutputState(['You spent $'+amt+' on your shopping trip.','Is there anything else I can help you with?']);
      } else if(bot.match(body,['how much', 'save', 'home'])){
        var amt = App.util.Obj.randomInt(80000,250000).toLocaleString();
        return new OutputState(["You've saved $"+amt+" for your first home so far.",'Is there anything else I can help you with?']);
      } else if(bot.match(body,['how much', 'save', 'down', 'pay'])){
        var amt = App.util.Obj.randomInt(80000,250000).toLocaleString();
        return new OutputState(["You have $"+amt+" saved for a downpayment.",'Is there anything else I can help you with?']);
      } else if(bot.match(body,'no')){
        return new OutputState("Ok, have a nice day!");
      } else{
        return new OutputState("Sorry, I didn't understand that. Can you rephrase that?");
      }
    };

    return AwaitState;
  })();

  var OutputState = (function(){
    function OutputState(seedMsg, nextState){
      State.call(this);
      this.id = StateManager.state.OUTPUT;
      this.seedMsg = seedMsg;
      if(!nextState){
        this.nextState = new AwaitState();
      }
    }
    OutputState.prototype = Object.create(State.prototype);
    OutputState.prototype.constructor = OutputState;

    OutputState.prototype.getStateMsg = function(){
      return this.seedMsg;
    };
    
    OutputState.prototype.needsResponse = function(){
      return false;
    };

    OutputState.prototype.getNextState = function(){
      return this.nextState;
    };

    return OutputState;
  })();

  var OfferState = (function(){
    function OfferState(rootContext){
      State.call(this);
      this.id = StateManager.state.OFFER;
      this.root = rootContext;
    }
    OfferState.prototype = Object.create(State.prototype);
    OfferState.prototype.constructor = OfferState;

    OfferState.prototype.getStateMsg = function(){
      var msgArr = ['Hello there, I thought this would interest you!:'];
      var offer = this.root.header;
      if(this.root.body){
        offer += ' - ' + this.root.body;
      }
      msgArr.push(offer);
      if(this.root.ctaLink){
        msgArr.push(this.root.ctaLink);
      }

      return msgArr;
    };

    OfferState.prototype.needsResponse = function(){
      return this.root.ctaLink && this.root.ctaLink.indexOf('?') > -1;
    };

    OfferState.prototype.getNextState = function(usrMsg){
      if(this.needsResponse()){
        var body = usrMsg.body.toLowerCase();
        var question = this.root.ctaLink? this.root.ctaLink.toLowerCase(): '';
        if(!bot.match(question,'how many points') && bot.match(body,'yes')){
          return new OutputState('Great, have a nice day!');
        } else if(bot.match(question,'how many points') && bot.match(body,'yes')){
          return new OutputState(['Your current points balance is 2000.','Have a nice day!']);
        } else if(bot.match(body,'balance')){
          return new OutputState(['Your current account balance is $10,000.','Is there anything else I can help you with?']);
        } else if(bot.match(body,['how much','trip']) && (bot.match(body,'spent') || bot.match(body,'spend'))){
          var amt = App.util.Obj.randomInt(1000,10000).toLocaleString();
          return new OutputState(['You spent $'+amt+' on your trip.','Is there anything else I can help you with?']);
        } else if(bot.match(body,['how much', 'shop']) && (bot.match(body,'spent') || bot.match(body,'spend'))){
          var amt = App.util.Obj.randomInt(1000,10000).toLocaleString();
          return new OutputState(['You spent $'+amt+' on your shopping trip.','Is there anything else I can help you with?']);
        } else if(bot.match(body,['how much', 'save', 'home'])){
          var amt = App.util.Obj.randomInt(80000,250000).toLocaleString();
          return new OutputState(["You've saved $"+amt+" for your first home so far.",'Is there anything else I can help you with?']);
        } else if(bot.match(body,['how much', 'save', 'down', 'pay'])){
          var amt = App.util.Obj.randomInt(80000,250000).toLocaleString();
          return new OutputState(["You have $"+amt+" saved for a downpayment.",'Is there anything else I can help you with?']);
        } else if(bot.match(body,'no')){
          return new OutputState("Ok, have a nice day!");
        } else{
          return new AwaitState();
        }
      } else{
        return new AwaitState();
      }
    };

    return OfferState;
  })();

  var StateManager = (function(){
    function StateManager(view){
      this.view = view;
      this.currentState = new State();
    }

    StateManager.state = StateManager.prototype.state = {
      GREETING: 'greeting',
      AWAIT: 'awaitcommand',
      NEUTRAL: 'neutralwait',
      OUTPUT: 'outputpassthrough',
      OFFER: 'offerstate'
    };

    StateManager.prototype.transitionTo = function(state){
      this.currentState = state;
      var msg = state.getStateMsg();
      if(msg && msg instanceof Array){
        var view = this.view;
        msg.forEach(function(m){
          view.appendChatLog(new Message({
            sender: 'bot',
            body: m
          }));
        })
      } else if(msg){
        this.view.appendChatLog(new Message({
          sender: 'bot',
          body: msg
        }));
      }
      if(!state.needsResponse()){
        this.transitionTo(state.getNextState());
      }
    };

    StateManager.prototype.userResponse = function(message){
      var newState = this.currentState.getNextState(message);
      if(newState){
        this.transitionTo(newState);
      }
    };

    return StateManager;
  })();

  
  return Vue.extend({
    template:'#hal9000',
    data: function(){
      return {
        userHistoryIndex: -1,
        userHistory: [],
        messages: [],
        currentMsg: '',
        isVisible: false,
        stateMachine: new StateManager(this)
      };
    },
    methods: {
      startConversation: function(context){
        var view = this;
        this.isVisible = false;
        setTimeout(function(){
          Vue.nextTick(function(){
            view.isVisible = true;
            view.$refs.chatbox.focus();
            if(!context){
              view.stateMachine.transitionTo(new GreetingState());
            } else{
              view.stateMachine.transitionTo(new OfferState(context));
            }
          });
        },150);
      },
      endConversation: function(){
        this.isVisible = false;
        this.currentMsg = '';
      },
      sendMessage: function(){
        if(!this.currentMsg){
          return;
        }
        var newMsg = new Message({
          sender: Message.ME,
          body: this.currentMsg
        });

        this.appendChatLog(newMsg);
        this.stateMachine.userResponse(newMsg);
        this.currentMsg = '';
        this.userHistory.unshift(newMsg);
        this.userHistoryIndex = -1;
      },
      appendChatLog: function(message){
        if(!(message instanceof Message)){
          return;
        }

        this.messages.push(message);
        var view = this;
        setTimeout(function(){
          var innerHeight = view.$refs.chatlogcontent.getBoundingClientRect().height;
          view.$refs.chatlog.scrollTop = innerHeight + 100;
        },10);
      },
      isOwnMsg: function(message){
        return message.sender === Message.ME;
      },
      getSenderIcon: function(message){
        if(!this.isOwnMsg(message)){
          return App.settings.theme.widgetIconURL;
        }
      },
      historyBack: function(){
        var msg = this.userHistory[this.userHistoryIndex + 1];
        if(msg){
          this.currentMsg = msg.body;
          this.userHistoryIndex++;
        }
      },
      historyForward: function(){
        var msg = this.userHistory[this.userHistoryIndex - 1];
        if(msg){
          this.currentMsg = msg.body;
          this.userHistoryIndex--;
        } else{
          this.currentMsg = '';
        }
      }
    },
    mounted: function(){
      var view = this;
      setTimeout(function(){
        App.evt.on(App.actions.CONVERSE, function(context){
          view.startConversation(context);
        });
      },100);
    }
  });
})();
Vue.component('hal9000',Hal9000);

var CardImage = CardBase.extend({
  template:'#card-image',
  data: function(){
    return {
      images: [],
    };
  },
  computed: {
    isMultiple: function(){
      return this.images.length > 1;
    },
  },
  methods: {
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.images = obj.images.data;
      });
    },
    isActionable: function(image){
      return image.deeplink;
    },
    styleType: function(image){
      return !image.style || image.style.toLowerCase() === 'card'? 'card-base':'nocard';
    },
    fitDivType: function(image){
      return !image.fit || (image.fit.toLowerCase() === 'cover' || image.fit.toLowerCase() === 'fit');
    },
    divStyle: function(image){
      var fit = image.fit?image.fit.toLowerCase():'cover';
      var retObj = {
        backgroundImage: 'url('+image.url+')'
      };
      if(fit === 'cover'){
        retObj.backgroundSize = 'cover';
      } else if(fit === 'fit'){
        retObj.backgroundSize = 'contain';
      }

      return retObj;
    },
    imgStyle: function(image){
      var fit = image.fit?image.fit.toLowerCase():'fit width';
      var retObj = {
        width: '100%',
        height: 'auto'
      };

      if(fit === 'fit height'){
        retObj.width = 'auto';
        retObj.height = '100%'
      }

      return retObj;
    },
    triggerAction: function(image){
      if(!this.isActionable(image)){
        return;
      }

      if(App.ctx.contentAnalytics){
        var contentCTX = {};
        contentCTX['engaged.'+this.content.id] = true;
        App.ctx.contentAnalytics.setState(contentCTX);
      }

      if(image.linkType === 'Chat Topic'){
        App.evt.emit(App.actions.CONVERSE, image.deeplink);
      } else if(image.linkType === 'Location'){
        App.openLink(this.gMapDirURL(image.deeplink));
      } else if(image.linkType === 'URL'){
        App.openLink(image.deeplink);
      }
    },
    gMapDirURL: function(address){
      if(address){
        return 'https://maps.google.com/maps/dir/?api=1&destination='+Flybits.util.Api.htmlEncode(address);
      }
      return '';
    },
  }
});
Vue.component('card-image',CardImage);

var CtnBenefits = CardBase.extend({
  template:'#ctn-benefits',
  data: function(){
    return {
      benefits: []
    };
  },
  computed: {
    isMultiple: function(){
      return this.benefits.length > 1;
    },
  },
  methods: {
    toValueObj: function(rootLocaleObj, propKey){
      return App.util.Obj.toValueObj(rootLocaleObj, propKey);
    },
    hasValue: function(valueObj){
      return Object.keys(valueObj).length;
    },
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.benefits = obj.benefits.data;
      });
    },
    hasValidColorStrip: function(benefit){
      return benefit.gradient && benefit.gradient.length;
    },
    getColorBG: function(benefit){
      var retObj = {};
      if(this.hasValidColorStrip(benefit)){
        if(benefit.gradient.length > 1){
          retObj.background = 'linear-gradient(to right,'+benefit.gradient.join(',')+')';
        } else{
          retObj.backgroundColor = benefit.gradient[0];
        }
      }

      return retObj;
    },
    getButtonColor: function(benefit){
      var retObj = {};
      if(benefit.primaryButton && benefit.primaryButton.color){
        retObj.border = "solid 1px "+benefit.primaryButton.color;
        retObj.color= benefit.primaryButton.color;
      }

      return retObj;
    },
    triggerAction: function(benefit){
      if(App.ctx.contentAnalytics){
        var contentCTX = {};
        contentCTX['engaged.'+this.content.id] = true;
        App.ctx.contentAnalytics.setState(contentCTX);
      }

      if(benefit && benefit.url){
        App.openLink(benefit.url);
      }
    }
  }
});
Vue.component('ctn-benefits',CtnBenefits);

var CtnOptin = CardBase.extend({
  template:'#ctn-optin',
  data: function(){
    return {
      root: {},
      primaryBGColor: '#ffffff',
      submitted: false
    };
  },
  computed: {
    submittedText: function(){
      return this.root.submittedText || 'Submitted ✓';
    }
  },
  methods: {
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        if(obj.gradientRange instanceof Flybits.PagedData){
          obj.gradientRange = obj.gradientRange.data;
        }
        view.root = obj;
      });
    },
    toValueObj: function(propKey, parent){
      var root = parent || this.root;
      return App.util.Obj.toValueObj(root, propKey);
    },
    hasValue: function(valueObj){
      return Object.keys(valueObj).length;
    },
    hasGradient: function(){
      return this.root.gradientRange && this.root.gradientRange.length;
    },
    getBG: function(){
      var retObj = {};
      if(this.hasGradient()){
        if(this.root.gradientRange.length > 1){
          retObj.background = 'linear-gradient(to right,'+this.root.gradientRange.join(',')+')';
        } else{
          retObj.backgroundColor = this.root.gradientRange[0];
        }
        this.primaryBGColor = this.root.gradientRange[0];
      } else if(this.root.backgroundColor){
        retObj.backgroundColor = this.root.backgroundColor;
        this.primaryBGColor = this.root.backgroundColor;
      }

      return retObj;
    },
    getBtnColor: function(button){
      if(button.color){
        return button.color;
      }
      return '#000000';
    },
    interact: function(affirmative){
      this.submitted = true;
      var ctx = {};
      if(App.ctx.interaction){
        ctx['isEngaged.'+this.content.id] = true;
        ctx['isRejected.'+this.content.id] = !affirmative;
        App.ctx.interaction.setState(ctx);
      }

      if(App.ctx.contentAnalytics){
        var contentCTX = {};
        contentCTX['engaged.'+this.content.id] = true;
        App.ctx.contentAnalytics.setState(contentCTX);
      }
    }
  }
});
Vue.component('ctn-optin',CtnOptin);

var AdaptiveFont = Vue.extend({
  template:'#adaptive-font',
  props: ['bgcolor'],
  computed: {
    styling: function(){
      var retObj = {};
      if(this.bgcolor){
        retObj.color = App.util.Obj.getContrastYIQ(this.bgcolor);
      }
      
      return retObj;
    }
  },
});
Vue.component('adaptive-font',AdaptiveFont);

var LocationSim = Vue.extend({
  template:'#location-sim',
  data: function(){
    return {
      isVisible: false,
      ctx: null,
      isEntering: false,
    };
  },
  computed: {
    actionVerb: function(){
      return this.isEntering?'ENTER':'LEAVE';
    }
  },
  methods: {
    show: function(bool){
      this.isVisible = bool;
      if(bool && App.ctx.location){
        this.ctx = App.ctx.location;
        if(this.ctx.lastObj && this.ctx.lastObj.lat !== 1.1){
          this.isEntering = false;
        } else if(this.ctx.lastObj && this.ctx.lastObj.lat === 1.1){
          this.isEntering = true;
        }
      } else{
        this.ctx = null;
      }
    },
    changeContext: function(){
      if(App.ctx.location){
        if(this.isEntering){
          App.ctx.location.setState(App.ctx.location.actual);
          this.immediateSend(App.ctx.location.actual);
        } else{
          App.ctx.location.setState(App.ctx.location.reset);
          this.immediateSend(App.ctx.location.reset);
        }
        this.show(false);
      }
    },
    immediateSend: function(locationObj){
      var url = Flybits.cfg.HOST + '/context/ctxdata';
      Flybits.util.Api.flbFetch(url, {
        method: 'POST',
        body: JSON.stringify([{
          dataTypeID: 'ctx.sdk.location',
          value: locationObj
        }]),
        respType: 'none'
      }).then(function(){
        console.log('> sent', JSON.stringify(locationObj));
      }).catch(function(e){
        console.log('> send failed', JSON.stringify(locationObj));
      });
    }
  },
  mounted: function(){
    var view = this;
    setTimeout(function(){
      App.evt.on(App.actions.PICKLOCATION, function(bool){
        view.show(bool);
      });
    },100);
  }
});
Vue.component('location-sim',LocationSim);

var LockScreen = Vue.extend({
  template:'#lock-screen',
  data: function(){
    return {
      isVisible: false,
      isDragging: false,
      dragger: null,
      timer: null,
      time: null
    }
  },
  computed: {
    timeStr: function(){
      var retStr = '';

      if(this.time){
        retStr = App.util.Obj.zero2Pad(this.time.getHours()) + ':' + App.util.Obj.zero2Pad(this.time.getMinutes());
      }

      return retStr;
    }
  },
  methods: {
    showScreen: function(bool){
      var view = this;
      this.isVisible = bool;
      if(bool){
        view.dragger = new MickDragger(view.$refs.dragBlock,{
          activationThreshold: 1,
          actionThreshold: 56,
          slideDirection: MickDragger.OMNIDIRECTIONAL
        });
        view.dragger.on(MickDragger.event.THRESHOLD, function(){
          App.evt.emit(App.actions.LOCKAPP, false);
        });
        view.startClock();
      } else{
        if(view.dragger){
          view.dragger.destroyListeners();
          view.dragger.clearMem();
          view.dragger.resetPosition();
          view.dragger = null;
        }
        view.endClock();
      }
    },
    startClock: function(){
      var view = this;
      this.endClock();
      view.time = new Date();
      console.log('> tick', view.time);
      this.timer = setInterval(function(){
        view.time = new Date();
        console.log('> tick', view.time);
      }, 60000);
    },
    endClock: function(){
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  mounted: function(){
    var view = this;
    setTimeout(function(){
      App.evt.on(App.actions.LOCKAPP, function(bool){
        view.showScreen(bool);
      });
    },100);
  }
});
Vue.component('lock-screen',LockScreen);

var CardTextlink = CardBase.extend({
  template:'#card-textlink',
  data: function(){
    return {
      root: {
        action: {
          type: null,
          value: null,
          text: null
        },
        header: null,
        title: null,
        description: null,
        image: null,
        variant: 0
      }
    };
  },
  computed: {
    variantClass: function(){
      return 'v-'+ this.root.variant;
    }
  },
  methods: {
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.root.action.type = obj.link.actionType;
        view.root.action.value = App.util.Obj.toValueObj(obj.link, 'actionValue');
        view.root.action.text = App.util.Obj.toValueObj(obj.link, 'text');
        view.root.header = App.util.Obj.toValueObj(obj, 'header');
        view.root.title = App.util.Obj.toValueObj(obj, 'title');
        view.root.image = App.util.Obj.toValueObj(obj, 'image');
        view.root.description = App.util.Obj.toValueObj(obj, 'description');
        try{
          view.root.variant = +obj.variant;
        } catch(e){
          console.log('> variant parse failed',e);
          view.root.variant = 0;
        }
      });
    },
    hasLocaleValue: function(localeObj){
      return localeObj && App.util.Obj.resolveLocalizedValue(localeObj)
    },
    actionTrigger: function(){
      if(App.ctx.contentAnalytics){
        var contentCTX = {};
        contentCTX['engaged.'+this.content.id] = true;
        App.ctx.contentAnalytics.setState(contentCTX);
      }
      
      if(this.hasLocaleValue(this.root.action.value)){
        var url = App.util.Obj.resolveLocalizedValue(this.root.action.value);
        if(this.root.action.type === App.actions.OPENDETAIL){
          App.router.push({
            name: 'textlink',
            params: {
              id: this.content.id
            }
          })
        } else if(this.root.action.type === App.actions.OPENLINK){
          App.openLink(url);
        } else if(this.root.action.type === 'goto' && url){
          App.gotoPageRoute(url);
        }
      }
    }
  }
});
Vue.component('card-textlink',CardTextlink);

var CardButtonlink = CardBase.extend({
  template:'#card-buttonlink',
  data: function(){
    return {
      root: {
        buttons: [],
        description: null,
        header: null,
        title: null,
        image: null
      }
    };
  },
  methods: {
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.root.header = App.util.Obj.toValueObj(obj, 'header');
        view.root.title = App.util.Obj.toValueObj(obj, 'title');
        view.root.image = App.util.Obj.toValueObj(obj, 'image');
        view.root.description = App.util.Obj.toValueObj(obj, 'description');
        view.root.buttons = obj.buttons.data.map(function(button){
          return {
            type: button.actionType,
            value: App.util.Obj.toValueObj(button, 'actionValue'),
            text: App.util.Obj.toValueObj(button, 'text')
          };
        });
      });
    },
    hasLocaleValue: function(localeObj){
      return localeObj && App.util.Obj.resolveLocalizedValue(localeObj)
    },
    actionTrigger: function(action, index){
      if(App.ctx.contentAnalytics){
        var contentCTX = {};
        contentCTX['engaged.'+this.content.id] = true;
        if(action.value){
          var actionText = App.util.Obj.resolveLocalizedValue(action.text);
          contentCTX['componentEngaged.'+this.content.id+'.btn'+(index+1)+'.'+actionText+'.button'] = true;
        }
        
        App.ctx.contentAnalytics.setState(contentCTX);
      }
      
      if(this.hasLocaleValue(action.value)){
        var url = App.util.Obj.resolveLocalizedValue(action.value);

        if(action.type === App.actions.OPENDETAIL){
          App.router.push({
            name: 'textlink',
            params: {
              id: this.content.id
            }
          })
        } else if(action.type === App.actions.OPENLINK){
          App.openLink(url);
        } else if(action.type === 'goto' && url){
          App.gotoPageRoute(url);
        }
      }
    }
  }
});
Vue.component('card-buttonlink',CardButtonlink);

var LocalizedBgimg = (function(){
  var resolveValue = function(localeObj,key){
    var localeKeys = Object.keys(localeObj);
    return localeObj[key] || localeObj['en'] || localeObj[localeKeys[0]];
  };

  return Vue.extend({
    template:'#localized-bgimg',
    props: {
      localeObj: {
        type: Object,
        default: function(){
          return {
            en: ''
          };
        }
      }
    },
    computed: {
      localizedStr: function(){
        return resolveValue(this.localeObj);
      }
    }
  });
})();
Vue.component('localized-bgimg',LocalizedBgimg);

var CardButtonlink = CardBase.extend({
  template:'#card-buttonlink',
  data: function(){
    return {
      root: {
        buttons: [],
        description: null,
        header: null,
        title: null,
        image: null
      }
    };
  },
  methods: {
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.root.header = App.util.Obj.toValueObj(obj, 'header');
        view.root.title = App.util.Obj.toValueObj(obj, 'title');
        view.root.image = App.util.Obj.toValueObj(obj, 'image');
        view.root.description = App.util.Obj.toValueObj(obj, 'description');
        view.root.buttons = obj.buttons.data.map(function(button){
          return {
            type: button.actionType,
            value: App.util.Obj.toValueObj(button, 'actionValue'),
            text: App.util.Obj.toValueObj(button, 'text')
          };
        });
      });
    },
    hasLocaleValue: function(localeObj){
      return localeObj && App.util.Obj.resolveLocalizedValue(localeObj)
    },
    actionTrigger: function(action, index){
      if(App.ctx.contentAnalytics){
        var contentCTX = {};
        contentCTX['engaged.'+this.content.id] = true;
        if(action.value){
          var actionText = App.util.Obj.resolveLocalizedValue(action.text);
          contentCTX['componentEngaged.'+this.content.id+'.btn'+(index+1)+'.'+actionText+'.button'] = true;
        }
        
        App.ctx.contentAnalytics.setState(contentCTX);
      }
      
      if(this.hasLocaleValue(action.value)){
        var url = App.util.Obj.resolveLocalizedValue(action.value);

        if(action.type === App.actions.OPENDETAIL){
          App.router.push({
            name: 'textlink',
            params: {
              id: this.content.id
            }
          })
        } else if(action.type === App.actions.OPENLINK){
          App.openLink(url);
        } else if(action.type === 'goto' && url){
          App.gotoPageRoute(url);
        }
      }
    }
  }
});
Vue.component('card-buttonlink',CardButtonlink);

var CardAccount = CardBase.extend({
  template:'#card-account',
  data: function(){
    return {
      header: '',
      footer: '',
      accounts: []
    };
  },
  filters: {
    monetize: function(val){
      if(val){
        return val.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        });
      }
      return '';
    }
  },
  methods: {
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.header = obj.header;
        view.footer = obj.footer;
        if(obj.accounts && obj.accounts instanceof Flybits.PagedData){
          obj.accounts.fetchAll().then(function(arr){
            view.accounts = arr;
          });
        }
      });
    },
    colorValue: function(val){
      if(val > 1000){
        return '#35b234';
      } else if(val < 0){
        return '#FF0000';
      }
      return '';
    }
  }
});
Vue.component('card-account',CardAccount);

var CardInsights = CardBase.extend({
  template:'#card-insights',
  data: function(){
    return {
      header: '',
      footer: '',
      goals: [],
      advisePanels: [],
      curAdvise: null,
      mode: 'goals' // goals ; advise
    };
  },
  computed: {
    hasStateIndicators: function(){
      return this.goals.length && this.advisePanels.length;
    }
  },
  methods: {
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.header = obj.header;
        view.footer = obj.footer;
        if(obj.goals && obj.goals instanceof Flybits.PagedData){
          obj.goals.fetchAll().then(function(arr){
            view.goals = arr;
          });
        }

        if(obj.advisePanels && obj.advisePanels instanceof Flybits.PagedData){
          obj.advisePanels.fetchAll().then(function(arr){
            view.advisePanels = arr;
            if(arr.length && !view.curAdvise){
              view.curAdvise = arr[0];
            } else if(arr.length && view.curAdvise){
              var curObj = view.advisePanels.filter(function(obj){
                return obj.header === view.curAdvise.header;
              })[0];
              if(curObj){
                view.curAdvise = curObj;
              } else{
                view.curAdvise = arr[0];
              }
            }
          });
        }
      });
    },
    isNotChoice: function(choice){
      return choice.actionType && choice.actionType === 'noop';
    },
    normalizeProgress: function(val){
      return val === 100?100:val % 100;
    },
    progressColorValue: function(val){
      val = this.normalizeProgress(val);
      if(val > 90){
        return '#7BA67C';
      } else if(val < 40){
        return '#F7C183';
      }
      return '#DAE5D7';
    },
    switchMode: function(newMode){
      if(newMode === 'advise'){
        this.mode = newMode;
        this.$refs.panels.scrollLeft = 1000;
      } else if(newMode === 'goals'){
        this.mode = newMode;
        this.$refs.panels.scrollLeft = 0;
      }
    },
    progressAdvise: function(){
      var view = this;
      if(this.curAdvise){
        var curObj = this.advisePanels.filter(function(obj){
          return obj.header === view.curAdvise.header;
        })[0];
        if(curObj){
          var curIndex = this.advisePanels.indexOf(curObj);
          if(curIndex !== this.advisePanels.length - 1){
            this.curAdvise = this.advisePanels[++curIndex];
          } else{
            this.curAdvise = this.advisePanels[0];
            this.switchMode('goals');
          }
        }
      }
    },
    selectChoice: function(choice){
      if(choice.actionType === 'content' && choice.action){
        App.gotoPageRoute(choice.action);
        this.curAdvise = this.advisePanels[0];
        this.switchMode('goals');
      } else if(choice.actionType === 'goto' && choice.action){
        if(choice.action === 'home'){
          App.router.push({name:'dashboard'})
        }
      } else{
        this.progressAdvise();
      }
    }
  }
});
Vue.component('card-insights',CardInsights);

var CardButtonarray = CardBase.extend({
  template:'#card-buttonarray',
  data: function(){
    return {
      header: '',
      description: '',
      icon: '',
      buttons: [],
    };
  },
  methods: {
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.header = obj.header;
        view.description = obj.description;
        view.icon = obj.icon;
        if(obj.buttonsList && obj.buttonsList instanceof Flybits.PagedData){
          obj.buttonsList.fetchAll().then(function(arr){
            view.buttons = arr;
          });
        }
      });
    },
    triggerButton: function(button){
      console.log('> trigger', button);
      if(App.ctx.contentAnalytics){
        var contentCTX = {};
        contentCTX['engaged.'+this.content.id] = true;
        App.ctx.contentAnalytics.setState(contentCTX);
      }
      
      if(button.actionType === 'content' && button.action){
        App.gotoPageRoute(button.action);
      } else if(button.actionType === 'goto' && button.action){
        if(button.action === 'home'){
          App.router.push({name:'dashboard'})
        }
      }
    }
  }
});
Vue.component('card-buttonarray',CardButtonarray);

var SplashPage = (function(){

  return {
    template: '#splash-page',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        vm.init();
      });
    },
    beforeRouteLeave: function(to, from, next){
      var now = new Date().getTime();
      var diff = now - this.loadStart;
      if(diff < 1500){
        setTimeout(function(){
          next();
        },1500-diff);
      } else{
        next();
      }
    },
    data: function(){
      return {
        disableBrand: false,
        isDefault: true,
        bkgURL: null,
      };
    },
    computed: {
      backStyle: function(){
        if(this.bkgURL){
          return 'background-image:url('+this.bkgURL+');opacity:1;';
        }

        return '';
      }
    },
    methods: {
      init: function(){
        
        if(App.settings.theme && App.settings.theme.splashURL){
          this.initSplash(App.settings.theme.splashURL);
        }
        
        var page = this;
        App.evt.on(App.actions.THEMEUPDATED, function(theme){
          page.disableBrand = App.cfg.disableBrand;
          page.initSplash(theme.splashURL);
        });
      },
      initSplash: function(url){
        if(url){
          var page = this;
          App.util.Browser.loadImage(url).then(function(){
            page.bkgURL = url;
            page.isDefault = false;
            page.loadStart = new Date().getTime();
          });
        } else{
          this.loadStart = new Date().getTime();
          this.isDefault = true;
        }
      }
    },
  };

})();
Vue.component('splash-page',SplashPage);
var SeedPage = (function(){

  var authOIDC = function(authObj){
    var idp = new OidcIDP({
      projectID: App.cfg.PROJECTID,
      idToken: authObj.token
    });
    return Flybits.Session.connect(idp);
  };

  var authOkta = function(authObj){
    var idp = new Flybits.idp.OAuthIDP({
      providerName: 'okta',
      projectID: App.cfg.PROJECTID,
      accessToken: authObj.token
    });
    return Flybits.Session.connect(idp);
  };

  var authJWT = function(authObj){
    Flybits.Session.setUserToken(authObj.token);
    return Flybits.api.User.getSignedInUser();
  };

  var authFlybitsIDP = function(authObj){
    var idp = new Flybits.idp.FlybitsIDP({
      email: authObj.ref,
      password: authObj.token,
      projectID: App.cfg.PROJECTID
    });
    return Flybits.Session.connect(idp);
  };

  return {
    template:'#seed-page',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        vm.disableBrand = App.cfg.disableBrand;
        
        if(!App.settings.profiles){
          return;
        }
        vm.expandableProfiles = App.settings.profiles.filter(function(profile){
          return !profile.isDisabled;
        }).map(function(profile){
          return {
            isExpanded: false,
            profile: profile
          };
        });
      });
    },
    beforeRouteLeave: function(to, from, next){
      App.evt.emit(App.actions.SCREENSAVE, true);
      next();
    },
    data: function(){
      return {
        expandableProfiles: [],
        isLoading: false,
        disableBrand: false
      };
    },
    methods: {
      selectProfile: function(profile){
        var view = this;
        this.isLoading = true;

        var promise = Promise.resolve();
        
        if(profile.authType === Profile.auth.OIDC){
          promise = authOIDC(profile.auth);
        } else if(profile.authType === Profile.auth.OKTA){
          promise = authOkta(profile.auth);
        } else if(profile.authType === Profile.auth.JWT){
          promise = authJWT(profile.auth);
        } else if(profile.authType === Profile.auth.FLYBITS){
          promise = authFlybitsIDP(profile.auth);
        }

        promise.then(function(){
          App.setSessionUser(Flybits.Session.user);
          App.evt.emit(App.actions.VIBRATE,{
            duration:100
          });
  
          App.setCTXProfile(profile);
          App.startPoll();
          
          setTimeout(function(){
            view.isLoading = false;
            App.router.push('dashboard');
          },1000);
        }).catch(function(e){
          view.isLoading = false;
          App.toast('Authentication failed','error');
          console.log(e);
        });
      },
      toggleExpand: function(expandable){
        expandable.isExpanded = !expandable.isExpanded;
      },
      formatCurrency: function(num, minimumFractionDigits){
        minimumFractionDigits = typeof minimumFractionDigits === 'number' ? minimumFractionDigits:2;
        return Number(num).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: minimumFractionDigits
        });
      }
    }
  };

})();
Vue.component('seed-page',SeedPage);
var Dashboard = (function(){

  return {
    template:'#dashboard',
    props: ['profile'],
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        vm.disableBrand = App.cfg.disableBrand;
        
        App.initNotifications();
        if(App.vm.sessionUser){
          App.store.getContents().then(function(arr){
            vm.contents = arr;
          });
        }
        vm.hasLocationCTX = App.vm.hasLocationCTX;
      });
    },
    data: function(){
      var dataObj = {
        contents: [],
        isExpanded: false,
        disableBrand: false,
        currentTab: null,
        hasLocationCTX: false
      };
      
      if(App.settings.theme.pills && App.settings.theme.pillsEnabled){
        dataObj.currentTab = App.settings.theme.pills[0];
      }

      return dataObj;
    },
    computed: {
      pills: function(){
        return App.settings.theme.pills;
      },
      pillsEnabled: function(){
        return App.settings.theme.pillsEnabled;
      },
      proxyContents: function(){
        var proxy = this.contents.filter(function(c){
          var internalType = App.cfg.templateMap[c.type];
          return internalType && internalType !== 'intro' && internalType !== 'cta' && internalType !== 'fullscreenimage';
        });

        if(this.pillsEnabled && this.pills && this.currentTab){
          var currentLabel = this.currentTab.label.toLowerCase();
          if(currentLabel !== 'all' && currentLabel !== 'for-you'){
            proxy = proxy.filter(function(c){
              return c.labels.filter(function(str){
                return str === currentLabel;
              })[0];
            });
          }
        }

        return proxy;
      },
      profileColor: function(){
        return this.profile?this.profile.color:'#005692';
      },
      fontColor: function(){
        return this.profile?App.util.Obj.getContrastYIQ(this.profile.color.substring(1)):'#ffffff';
      },
      profileLabel: function(){
        return this.profile?this.profile.name:'';
      }
    },
    methods: {
      resolveCardType: function(content){
        var internalType = App.cfg.templateMap[content.type];
        if(internalType && internalType.indexOf('-') < 0){
          internalType = 'card-'+internalType;
        }

        return internalType;
      },
      formatCurrency: function(num, minimumFractionDigits){
        minimumFractionDigits = typeof minimumFractionDigits === 'number' ? minimumFractionDigits:2;
        return Number(num).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: minimumFractionDigits
        });
      },
      formatLocation: function(str){
        return App.util.Obj.replaceAllStr(str, '-', ' ');
      },
      toggleExpand: function(){
        this.isExpanded = !this.isExpanded;
      },
      isTabSelected: function(pill){
        return pill === this.currentTab?'selected':'';
      },
      selectTab: function(pill){
        this.currentTab = pill;
      },
      pickLocation: function(){
        App.evt.emit(App.actions.PICKLOCATION, true);
      }
    },
    mounted: function(){
      var startX = 0;
      var currentX = 0;
      var isMenuTouching = false;
      var touchStart = function(e){
        startX = e.pageX || e.touches[0].pageX;
        if(startX <= 20){
          isMenuTouching = true;
        }
      };
      var touchMove = function(e){
        currentX = e.pageX || e.touches[0].pageX;
      };
      var touchEnd = function(e){
        if(isMenuTouching && currentX >= 50){
          App.evt.emit(App.actions.MAIN_MENU,true);
        }
        isMenuTouching = false;
      };
      $(this.$el).on('touchstart',touchStart);
      $(this.$el).on('touchmove',touchMove);
      $(this.$el).on('touchend',touchEnd);
    }
  };

})();
Vue.component('dashboard',Dashboard);
var PageCta = (function(){

  return {
    template:'#page-cta',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContent(to.params.id).then(function(content){
            vm.content = content;

            if(App.ctx.interaction){
              var ctx = {};
              ctx['isViewed.'+content.id] = true
              App.ctx.interaction.setState(ctx);
            }
            if(App.ctx.contentAnalytics){
              var contentCTX = {};
              contentCTX['viewed.'+this.content.id] = true;
              App.ctx.contentAnalytics.setState(contentCTX);
            }
            App.evt.emit(App.actions.VIBRATE,{
              pattern: [400,40,400]
            });
          });
        }
      });
    },
    data: function(){
      return {
        root: {
          bannerURL: '',
          title: {},
          body: {},
          ctaBtn: {},
          dismissBtn: {},
          actionURL: ''
        },
        content: {
          data: {}
        }
      };
    },
    computed: {
      themeColor: function(){
        return App.vm.currentProfile.color || "#005692";
      }
    },
    watch: {
      'content.data': function(newVal, oldVal){
        var view = this;
        this.content.getData().then(function(obj){
          view.root.bannerURL = obj.img;
          view.root.title = App.util.Obj.toValueObj(obj,'title'); 
          view.root.body = App.util.Obj.toValueObj(obj,'description'); 
          view.root.ctaBtn = App.util.Obj.toValueObj(obj,'ctaButton'); 
          view.root.dismissBtn = App.util.Obj.toValueObj(obj,'dismissButton'); 
          view.root.actionURL = obj.url;
        });
      }
    },
    methods: {
      dismiss: function(){
        App.router.back();
      },
      accept: function(){
        if(this.root.actionURL && this.root.actionURL !== ''){
          App.openLink(this.root.actionURL);
        }

        if(App.ctx.contentAnalytics){
          var contentCTX = {};
          contentCTX['engaged.'+this.content.id] = true;
          App.ctx.contentAnalytics.setState(contentCTX);
        }
        
        App.router.back();
      },
      dataChanged: function(){
        var view = this;
        App.store.getContent(this.content.id, App.store.CACHEFIRST).then(function(result){
          if(!result){
            if(view.$route.name === 'cta'){
              App.router.back();
            }
            App.evt.off(App.actions.DATACHANGED, view.dataChanged);
          }
        })
      }
    },
    mounted: function(){
      var view = this;
      App.ready.then(function(){
        App.evt.on(App.actions.DATACHANGED,view.dataChanged);
      });
    }
  };

})();
Vue.component('page-cta',PageCta);
var PageEvent = (function(){

  return {
    template:'#page-event',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContent(to.params.id).then(function(content){
            vm.content = content;
          });
        }
      });
    },
    data: function(){
      return {
        root: {
          title: {},
          location: {},
          address: {},
          description: {},
          registerURL: '',
          bannerURL: '',
          dateISO: '',
        },
        content: {
          data: {}
        }
      };
    },
    computed: {
      dateStr: function(){
        if(!this.root.dateISO || this.root.dateISO === ''){
          return '';
        }
        var d = new Date(this.root.dateISO);
  
        return d.getMonthName() + ' ' +
               d.getDate() + ', ' +
               d.getFullYear() + ' - ' +
               App.util.Obj.zero2Pad(d.getHours()) + ':' + 
               App.util.Obj.zero2Pad(d.getMinutes());
      },
      themeColor: function(){
        return App.vm.currentProfile.color || "#005692";
      }
    },
    watch: {
      'content.data': function(newVal, oldVal){
        var view = this;
        this.content.getData().then(function(obj){
          view.root.title = App.util.Obj.toValueObj(obj,'title');
          view.root.description = App.util.Obj.toValueObj(obj,'description');
          view.root.location = App.util.Obj.toValueObj(obj,'location');
          view.root.address = App.util.Obj.toValueObj(obj,'address');
          view.root.bannerURL = obj.img;
          view.root.registerURL = obj.registerURL;
          view.root.dateISO = obj.date;
        });
      }
    },
    methods: {
      gMapDirURL: function(address){
        if(address){
          return 'https://maps.google.com/maps/dir/?api=1&destination='+Flybits.util.Api.htmlEncode(address);
        }
        return '';
      },
      registerAction: function(){
        App.openLink(this.root.registerURL);
      },
      detailAction: function(url,type){
        if(type === 'map'){
          App.openLink(this.gMapDirURL(url));
        } else{
          App.openLink(url);
        }
      }
    }
  };

})();
Vue.component('page-event',PageEvent);
var PageVideo = (function(){

  return {
    template:'#page-video',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContent(to.params.id).then(function(content){
            vm.content = content;
          });
        }
      });
    },
    data: function(){
      return {
        videos: [],
        content: {
          data: {}
        }
      };
    },
    computed: {
      headerTitle: function(){
        return this.content && this.content.locales? this.content.locales.en.name:'';
      }
    },
    watch: {
      'content.data': function(newVal, oldVal){
        var view = this;
        this.content.getData().then(function(obj){
          view.videos = obj.video.data;
        });
      }
    },
    methods: {
      videoPlay: function(vid){
        var ctx = {};
        ctx['viewed.'+App.util.Model.resolveTopicParam(this.content)] = true;
        // App.ctx.data.setState(ctx);
      }
    }
  };

})();
Vue.component('page-video',PageVideo);
var Tabbed = (function(){

  return {
    template:'#tabbed',
    props: ['profile'],
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(to.path !== '/tabbed'){
          vm.isHome = false;
        } else{
          vm.isHome = true;
        }
        vm.init();
      });
    },
    data: function(){
      return {
        bkgURL: null,
        widgetIconURL: null,
        isHome: true,
        fontColor: '#ffffff'
      };
    },
    computed: {
      backStyle: function(){
        if(this.bkgURL){
          return 'background-image:url('+this.bkgURL+');opacity:1;';
        }

        return null;
      },
      iconURL: function(){
        return this.widgetIconURL || 'images/logoIcon_white.svg';
      },
    },
    methods: {
      init: function(){
        if(App.settings.theme && App.settings.theme.appscreenURL){
          var page = this;

          this.fontColor = App.util.Obj.getContrastYIQ(App.settings.theme.primaryColor.substring(1));

          App.util.Browser.loadImage(App.settings.theme.appscreenURL).then(function(){
            page.bkgURL = App.settings.theme.appscreenURL;
          });
          App.util.Browser.loadImage(App.settings.theme.widgetIconURL).then(function(){
            page.widgetIconURL = App.settings.theme.widgetIconURL;
          });
        }
      },
      showSeed: function(){
        this.isHome = false;
        App.router.push('/tabbed/seed');
        this.$el.querySelectorAll('.tab-bar .opt').forEach(function(elem){
          if(elem.classList.contains('seed-link')){
            elem.classList.add('selected');  
          } else{
            elem.classList.remove('selected');
          }
        });
      },
      revert: function(){
        this.isHome = true;
        App.router.push('/tabbed');
        this.$el.querySelectorAll('.tab-bar .opt').forEach(function(elem){
          if(elem.classList.contains('home')){
            elem.classList.add('selected');  
          } else{
            elem.classList.remove('selected');
          }
        });
      }
    }
  };

})();
Vue.component('tabbed',Tabbed);
var Widget = (function(){

  return {
    template:'#widget',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        vm.init();
      });
    },
    data: function(){
      return {
        bkgURL: null,
        widgetIconURL: null,
        activated: false,
      };
    },
    computed: {
      backStyle: function(){
        if(this.bkgURL){
          return 'background-image:url('+this.bkgURL+');opacity:1;';
        }

        return null;
      },
      iconURL: function(){
        return this.widgetIconURL || 'images/logoIcon_white.svg';
      }
    },
    methods: {
      init: function(){
        this.activated = false;

        if(App.settings.theme && App.settings.theme.appscreenURL){
          var page = this;
          App.util.Browser.loadImage(App.settings.theme.appscreenURL).then(function(){
            page.bkgURL = App.settings.theme.appscreenURL;
          });
          App.util.Browser.loadImage(App.settings.theme.widgetIconURL).then(function(){
            page.widgetIconURL = App.settings.theme.widgetIconURL;
          });
        }
      },
      showSeed: function(){
        this.activated = true;
        setTimeout(function(){
          App.router.push('/seed');
        },400);
      }
    }
  };

})();
Vue.component('widget',Widget);
var PageFullscreenimage = (function(){

  return {
    template:'#page-fullscreenimage',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContent(to.params.id).then(function(content){
            vm.content = content;

            if(App.ctx.contentAnalytics){
              var contentCTX = {};
              contentCTX['viewed.'+content.id] = true;
              App.ctx.contentAnalytics.setState(contentCTX);
            }
          });
        }
      });
    },
    beforeRouteUpdate: function(to, from, next){
      var vm = this;
      if(App.vm.sessionUser){
        App.store.getContent(to.params.id).then(function(content){
          vm.content = content;

          if(App.ctx.contentAnalytics){
            var contentCTX = {};
            contentCTX['viewed.'+content.id] = true;
            App.ctx.contentAnalytics.setState(contentCTX);
          }
        });
      }
      next();
    },
    data: function(){
      return {
        root: {
          url: '',
          action: null,
          actionType: null,
          fit: null
        },
        content: {
          data: {}
        }
      };
    },
    computed: {
      divStyle: function(){
        var fit = this.root.fit?this.root.fit.toLowerCase():'cover';
        var retObj = {
          backgroundImage: 'url('+this.root.url+')'
        };
        if(fit === 'cover'){
          retObj.backgroundSize = 'cover';
        } else if(fit === 'fit'){
          retObj.backgroundSize = 'contain';
        } else if(fit.indexOf('fit') > -1){
          retObj.backgroundSize = '100% auto';
        }
  
        return retObj;
      }
    },
    watch: {
      'content.data': function(newVal, oldVal){
        var view = this;
        this.content.getData().then(function(obj){
          view.root.url = obj.image;
          view.root.action = obj.deeplink;
          view.root.actionType = obj.linkType;
          view.root.fit = obj.fit;
        });
      }
    },
    methods: {
      dismiss: function(){
        if(App.ctx.contentAnalytics){
          var contentCTX = {};
          contentCTX['engaged.'+this.content.id] = true;
          App.ctx.contentAnalytics.setState(contentCTX);
        }

        if(this.root.action && this.root.action !== ''){
          if(this.root.actionType === 'content' || this.root.actionType === 'Content Page'){
            App.gotoPageRoute(this.root.action);
          } else if(this.root.actionType === 'goto'){
            if(this.root.action === 'home'){
              App.router.push({name:'dashboard'})
            }
          } else{
            App.openLink(this.root.action);
            App.router.back();
          }
        } else{
          App.router.back();
        }

      },
      dataChanged: function(){
        var view = this;
        App.store.getContent(this.content.id, App.store.CACHEFIRST).then(function(result){
          if(!result){
            if(view.$route.name === 'image'){
              App.router.back();
            }
            App.evt.off(App.actions.DATACHANGED, view.dataChanged);
          }
        })
      }
    },
    mounted: function(){
      var view = this;
      App.ready.then(function(){
        App.evt.on(App.actions.DATACHANGED,view.dataChanged);
      });
    }
  };

})();
Vue.component('page-fullscreenimage',PageFullscreenimage);
var PageWeb = (function(){

  return {
    template:'#page-web',
    beforeRouteEnter: function(to, from, next){
      var url = to.query && to.query.url?to.query.url:null;
      var backRoute = to.query && to.query.back?to.query.back:null;

      if(url){
        next(function(vm){
          vm.url = url;
          vm.routeReturn = backRoute;
        });
      } else{
        next(false);
      }
        
    },
    data: function(){
      return {
        isLoading: false,
        $webview: null,
        $webframe: null,
        url: '',
        routeReturn: '',
      };
    },
    watch: {
      url: function(newVal, oldVal){
        this.setURL(newVal);
      }
    },
    methods: {
      setURL: function(url){
        var view = this;
        if(url){
          this.isLoading = true;
          this.$webview = document.createElement('iframe');
          this.$webview.setAttribute('src', url);
          // this.$webview.setAttribute('sandbox','allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-scripts allow-top-navigation allow-top-navigation-by-user-activation');
          this.$webview.onload = function(){
            view.isLoading = false;
          };
          this.$webframe.appendChild(this.$webview);
        } else{
          this.$webframe.innerHTML = '';
        }
      },
      dismiss: function(){
        App.router.back();
      },
    },
    mounted: function(){
      this.$webframe = this.$el.querySelector('.frame-wrapper');
    }
  };

})();
Vue.component('page-web',PageWeb);
var PageTextlink = (function(){

  return {
    template:'#page-textlink',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContent(to.params.id).then(function(content){
            vm.content = content;
          });
        }
      });
    },
    data: function(){
      return{
        root: {
          header: null,
          title: null,
          description: null,
          image: null,
          detail: null
        },
        content: {
          data: {}
        }
      }
    },
    watch: {
      'content.data': function(newVal, oldVal){
        var view = this;
        this.content.getData().then(function(obj){
          view.root.title = App.util.Obj.toValueObj(obj,'title');
          view.root.description = App.util.Obj.toValueObj(obj,'description');
          view.root.header = App.util.Obj.toValueObj(obj,'header');
          view.root.image = App.util.Obj.toValueObj(obj, 'image');
          view.root.detail = App.util.Obj.toValueObj(obj.details, 'body');
        });
      }
    },
    methods: {
      back: function(){
        if(App.ctx.contentAnalytics){
          var contentCTX = {};
          contentCTX['componentEngaged.'+this.content.id+'.detaildismiss.Back.button'] = true;
          
          App.ctx.contentAnalytics.setState(contentCTX);
        }

        App.router.back();
      }
    }
  };

})();
Vue.component('page-textlink',PageTextlink);
var PageButtonlink = (function(){

  return {
    template:'#page-buttonlink',
  };

})();
Vue.component('page-buttonlink',PageButtonlink);
var PageInfo = (function(){

  return {
    template:'#page-info',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContent(to.params.id).then(function(content){
            vm.content = content;

            if(App.ctx.contentAnalytics){
              var contentCTX = {};
              contentCTX['viewed.'+content.id] = true;
              App.ctx.contentAnalytics.setState(contentCTX);
            }
          });
        }
      });
    },
    data: function(){
      return {
        content: {
          data: {}
        },
        banner: null,
        header: null,
        description: null,
        table: [],
        button: {
          actionType: null,
          action: null,
          label: null
        }
      };
    },
    watch: {
      'content.data': function(newVal, oldVal){
        var view = this;
        this.content.getData().then(function(obj){
          view.banner = obj.banner;
          view.header = obj.header;
          view.description = obj.description;
          if(obj.button){
            view.button.actionType = obj.button.actionType;
            view.button.action = obj.button.action;
            view.button.label = obj.button.label;
          }
          if(obj.table && obj.table instanceof Flybits.PagedData){
            obj.table.fetchAll().then(function(arr){
              view.table = arr;
            });
          }
        });
      }
    },
    methods: {
      calcColWidth: function(columns){
        return columns?(100/columns.length) + '%':0;
      },
      mainAction: function(button){
        if(App.ctx.contentAnalytics){
          var contentCTX = {};
          contentCTX['engaged.'+this.content.id] = true;
          App.ctx.contentAnalytics.setState(contentCTX);
        }
        
        if(button.actionType === 'content' && button.action){
          App.gotoPageRoute(button.action);
        } else if(button.actionType === 'goto' && button.action){
          if(button.action === 'home'){
            App.router.push({name:'dashboard'})
          }
        }
      },
      dismiss: function(){
        if(App.ctx.contentAnalytics){
          var contentCTX = {};
          contentCTX['engaged.'+this.content.id] = true;
          App.ctx.contentAnalytics.setState(contentCTX);
        }

        App.router.back();
      }
    }
  };

})();
Vue.component('page-info',PageInfo);
var PageInfofeedback = (function(){

  return {
    template:'#page-infofeedback',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContent(to.params.id).then(function(content){
            vm.content = content;

            if(App.ctx.contentAnalytics){
              var contentCTX = {};
              contentCTX['viewed.'+content.id] = true;
              App.ctx.contentAnalytics.setState(contentCTX);
            }
          });
        }
      });
    },
    data: function(){
      return {
        content: {
          data: {}
        },
        icon: null,
        header: null,
        description: null,
        iconCaption: null,
        listLabel: null,
        list: [],
        button: {
          actionType: null,
          action: null,
          label: null
        },
        subAction: {
          linkLabel: null,
          header: null,
          options: []
        },
        subActionOpen: false,
      };
    },
    watch: {
      'content.data': function(newVal, oldVal){
        var view = this;
        this.content.getData().then(function(obj){
          view.icon = obj.icon;
          view.iconCaption = obj.iconCaption;
          view.listLabel = obj.listLabel;
          view.header = obj.header;
          view.description = obj.description;
          if(obj.button){
            view.button.actionType = obj.button.actionType;
            view.button.action = obj.button.action;
            view.button.label = obj.button.label;
          }
          if(obj.list && obj.list.data){
            view.list = obj.list.data;
          }
          if(obj.subAction){
            view.subAction.linkLabel = obj.subAction.linkLabel;
            view.subAction.header = obj.subAction.header;
            view.subAction.options = obj.subAction.options;
          }
          if(obj.subActions){
            view.subAction.options = obj.subActions.data;
          }
        });
      }
    },
    methods: {
      dismiss: function(){
        if(App.ctx.contentAnalytics){
          var contentCTX = {};
          contentCTX['engaged.'+this.content.id] = true;
          App.ctx.contentAnalytics.setState(contentCTX);
        }

        App.router.back();
      },
      mainAction: function(button){
        if(App.ctx.contentAnalytics){
          var contentCTX = {};
          contentCTX['engaged.'+this.content.id] = true;
          App.ctx.contentAnalytics.setState(contentCTX);
        }
        
        if(button.actionType === 'content' && button.action){
          App.gotoPageRoute(button.action);
        } else if(button.actionType === 'goto' && button.action){
          if(button.action === 'home'){
            App.router.push({name:'dashboard'})
          }
        }
      },
      subActionTrigger: function(action){
        if(action.actionType && action.actionType === 'subaction'){
          if(App.ctx.contentAnalytics){
            var contentCTX = {};
            contentCTX['engaged.'+this.content.id] = true;
            App.ctx.contentAnalytics.setState(contentCTX);
          }
          console.log('> engaged', this.content.id);
        }
        this.closeSubActions();
      },
      closeSubActions: function(){
        this.subActionOpen = false;
      },
      openSubActions: function(){
        this.subActionOpen = true;
      }
    }
  };

})();
Vue.component('page-infofeedback',PageInfofeedback);
var PageChat = (function(){

  var isAdding = false;
  var delayedAdd = function(fn, sourceArr){
    if(sourceArr.length){
      Vue.nextTick(function(){
        setTimeout(function(){
          fn(sourceArr.shift());
          delayedAdd(fn, sourceArr);
        }, 250);
      });
    } else{
      isAdding = false;
    }
  };

  return {
    template:'#page-chat',
    props: ['profile'],
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContent(to.params.id).then(function(content){
            vm.content = content;

            if(App.ctx.contentAnalytics){
              var contentCTX = {};
              contentCTX['viewed.'+content.id] = true;
              App.ctx.contentAnalytics.setState(contentCTX);
            }
          });
        }
        vm.$refs.chatbox.focus();
      });
    },
    data: function(){
      return {
        content: {
          data: {}
        },
        botIcon: '',
        userIcon: '',
        header: '',
        conversation: [],
        currentMsg: '',
      }
    },
    computed: {
      profileColor: function(){
        return this.profile?this.profile.color:'#005692';
      },
      fontColor: function(){
        return this.profile?App.util.Obj.getContrastYIQ(this.profile.color.substring(1)):'#ffffff';
      },
    },
    watch: {
      'content.data': function(newVal, oldVal){
        var view = this;
        this.content.getData().then(function(obj){
          view.header = obj.header;
          view.botIcon = obj.botIcon;
          view.userIcon = obj.userIcon;
          if(obj.conversationSeed && obj.conversationSeed instanceof Flybits.PagedData){
            obj.conversationSeed.fetchAll().then(function(arr){
              if(!view.conversation.length && !isAdding){
                isAdding = true;
                delayedAdd(view.appendMessage, arr);
              }
            });
          }
        });
      }
    },
    methods: {
      dismiss: function(){
        if(App.ctx.contentAnalytics){
          var contentCTX = {};
          contentCTX['engaged.'+this.content.id] = true;
          App.ctx.contentAnalytics.setState(contentCTX);
        }

        App.router.back();
      },
      getSenderIcon: function(message){
        if(message.type === 'bot' && this.botIcon){
          return this.botIcon;
        } else if(message.type === 'user' && this.userIcon){
          return this.userIcon;
        }
      },
      appendMessage: function(msg){
        this.conversation.push(msg);
        var view = this;
        Vue.nextTick(function(){
          view.$refs.chatcontainer.scrollTop = view.$refs.chatcontainer.scrollTop + view.$refs.chatwrap.clientHeight;
        })
      },
      sendMessage: function(){
        if(this.currentMsg){
          this.appendMessage({
            paragraphs: [this.currentMsg],
            type: 'user'
          })
          this.currentMsg = '';
        }
      },
      triggerAction: function(button){
        if(App.ctx.contentAnalytics){
          var contentCTX = {};
          contentCTX['engaged.'+this.content.id] = true;
          App.ctx.contentAnalytics.setState(contentCTX);
        }
        
        if(button.actionType === 'content' && button.action){
          App.gotoPageRoute(button.action);
        } else if(button.actionType === 'goto' && button.action){
          if(button.action === 'home'){
            App.router.push({name:'dashboard'})
          }
        }
      }
    }
  };

})();
Vue.component('page-chat',PageChat);
var PageImagedetail = (function(){

  return {
    template:'#page-imagedetail',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContent(to.params.id).then(function(content){
            vm.content = content;

            if(App.ctx.contentAnalytics){
              var contentCTX = {};
              contentCTX['viewed.'+content.id] = true;
              App.ctx.contentAnalytics.setState(contentCTX);
            }
          });
        }
      });
    },
    data: function(){
      return {
        content: {
          data: {}
        },
        icon: null,
        header: null,
        description: null,
        contentImage: null,
        button: {
          actionType: null,
          action: null,
          label: null
        },
      };
    },
    watch: {
      'content.data': function(newVal, oldVal){
        var view = this;
        this.content.getData().then(function(obj){
          view.icon = obj.icon;
          view.header = obj.header;
          view.description = obj.description;
          view.contentImage = obj.contentImage;
          if(obj.button){
            view.button.actionType = obj.button.actionType;
            view.button.action = obj.button.action;
            view.button.label = obj.button.label;
          }
        });
      }
    },
    methods: {
      dismiss: function(){
        if(App.ctx.contentAnalytics){
          var contentCTX = {};
          contentCTX['engaged.'+this.content.id] = true;
          App.ctx.contentAnalytics.setState(contentCTX);
        }

        App.router.back();
      },
      triggerAction: function(button){
        if(App.ctx.contentAnalytics){
          var contentCTX = {};
          contentCTX['engaged.'+this.content.id] = true;
          App.ctx.contentAnalytics.setState(contentCTX);
        }
        
        if(button.actionType === 'content' && button.action){
          App.gotoPageRoute(button.action);
        } else if(button.actionType === 'goto' && button.action){
          if(button.action === 'home'){
            App.router.push({name:'dashboard'})
          }
        }
      }
    }
  };

})();
Vue.component('page-imagedetail',PageImagedetail);
var PageSelection = (function(){

  return {
    template:'#page-selection',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContent(to.params.id).then(function(content){
            vm.content = content;

            if(App.ctx.contentAnalytics){
              var contentCTX = {};
              contentCTX['viewed.'+content.id] = true;
              App.ctx.contentAnalytics.setState(contentCTX);
            }
          });
        }
      });
    },
    data: function(){
      return {
        content: {
          data: {}
        },
        header: null,
        prompt: null,
        finePrint: null,
        options: []
      };
    },
    watch: {
      'content.data': function(newVal, oldVal){
        var view = this;
        this.content.getData().then(function(obj){
          view.header = obj.header;
          view.prompt = obj.prompt;
          view.finePrint = obj.finePrint;
          if(obj.options && obj.options instanceof Flybits.PagedData){
            obj.options.fetchAll().then(function(arr){
              view.options = arr;
            })
          }
        });
      }
    },
    methods: {
      dismiss: function(){
        if(App.ctx.contentAnalytics){
          var contentCTX = {};
          contentCTX['engaged.'+this.content.id] = true;
          App.ctx.contentAnalytics.setState(contentCTX);
        }
  
        App.router.push({
          name: 'dashboard'
        });
      },
    }
  };

})();
Vue.component('page-selection',PageSelection);
var App = (function(){
  var deferredReady = new Deferred();
  
  var resolveSeenContentInstances = function(ciArr){
    var retObj = {
      seen: [],
      notSeen: []
    };
    ciArr.forEach(function(ci){
      var seenStatus = App.store.prop.ciViewed.get(ci.id);
      if(seenStatus){
        retObj.seen.push(ci);
      } else{
        retObj.notSeen.push(ci);
      }
    });

    return retObj;
  };

  var App = {
    ready: deferredReady.promise,
    vm: null,
    evt: null,
    ext:{
      CONFIG:"res/config.json",
      VERSION: 'version.txt'
    },
    actions:{
      LOADING: "loading",
      CONFIG_UPDATE: "configupdated",
      VIBRATE: 'vibrate',
      MAIN_MENU: 'mainmenutrigger',
      DATACHANGED: 'datachanged',
      IOSPUSH: 'iosnotification',
      PUSH: 'notification',
      THEMEUPDATED: 'themeupdated',
      CONVERSE: 'converse',
      PICKLOCATION: 'picklocation',
      LOCKAPP: 'lockapp',
      SCREENSAVE: 'screensave',
      OPENLINK: 'LINK',
      OPENDETAIL: 'OPEN_DETAIL'
    },
    ctx: {},
    cfg: {},
    util: {},
    notificationManager: null,
    initConfig:function(){
      var app = this;
      var def = new Deferred();

      fetch(this.ext.CONFIG).then(function(resp){
        if(resp.status !== 200){
          throw new Validation().addError("Configuration file not found","Reverting to default configuration. No configuration found at:"+app.ext.CONFIG,{
            code: Flybits.Validation.type.MISSINGARG
          });
        }
        return resp.json();
      }).then(function(json){
        app.cfg = App.util.Obj.extend(app.cfg,json.defaults);
        app.vm.isDebug = app.cfg.debug;
        app.vm.disableBrand = app.cfg.disableBrand;
        def.resolve(app.cfg);
      }).catch(function(ex){
        if(ex instanceof Validation){
          def.reject(ex);
        } else{
          def.reject(new Validation().addError("Failed to read configuration file.","Reverting to default configuration. Configuration format incorrect at:"+app.ext.CONFIG,{
            code: Validation.type.MALFORMED
          }));
        }
      });

      return def.promise;
    },
    initNotifications: function(){
      var app = this;
      if(!this.notificationManager){
        NotificationManagerFactory.getManager().then(function(manager){
          app.notificationManager = manager;
        }).catch(function(e){
          console.log('> failed to retrieve notification manager');
        });
      }
    },
    checkVersion: function(){
      fetch(this.ext.VERSION).then(function(resp){
        return resp.text();
      }).then(function(fileStr){
        App.vm.version = fileStr;
        console.debug(fileStr);
      });
    },
    initSDK: function(){
      var def = new Flybits.Deferred();
      Flybits.init({
        HOST: this.cfg.HOST,
        CTXREPORTDELAY: this.cfg.CTXREPORTDELAY
      }).then(function(){
        def.resolve();
      });

      return def.promise;
    },
    initCTX: function(){
      var def = new Flybits.Deferred();

      Flybits.context.Manager.initialize().then(function(){
        return;
      }).then(function(){
        def.resolve();
      });

      return def.promise;
    },
    clearSession: function(){
      this.store.flushAll();
      this.vm.sessionUser = null;
    },
    setSessionUser: function(user){
      this.vm.sessionUser = user;
    },
    login: function(){
      return Flybits.Session.connect(new Flybits.idp.AnonymousIDP({
        projectID: App.cfg.PROJECTID
      }));
    },
    resolvedRouteName: function(content){
      var type = content?content.type:undefined;
      var routeName = App.cfg.templateMap[type];
      return routeName || 'error';
    },
    /**
     * @deprecated
     */
    goto: function(content,noHistory){
      var routeName = this.resolvedRouteName(content);
      var routeFn = noHistory?'replace':'push';
      App.router[routeFn]({
        name: routeName,
        params:{
          id: content?content.id:''
        }
      });
      if(!routeName){
        App.vm.errorText = 'Unsupported Content';
      }
    },
    gotoPageRoute: function(contentID){
      if(App.vm.sessionUser){
        App.store.getContent(contentID).then(function(content){
          if(content && App.routeTemplateMap[content.type]){
            router.push({
              name: App.routeTemplateMap[content.type],
              params: {
                id: content.id
              }
            });
          } else{
            console.log('> no route found for content:', content);
          }
        });
      }
    },
    openLink: function(url){
      if(url && url.indexOf('flbembed=true') > -1){
        App.router.push({
          name: 'web',
          query: {
            url: url
          }
        });
      } else{
        window.open(url, '_blank');
      }
    },
    evaluateCTA: function(contentArr){
      var curRouteName = App.vm.$route.name;
      if(curRouteName === 'login' || curRouteName === 'intro' || curRouteName === 'cta' || curRouteName === 'splash' || curRouteName === 'seed' || curRouteName === 'tabbed' || curRouteName === 'widget' || 
      curRouteName === 'tabbedSeed'){
        return;
      }
      
      var ctas = contentArr.filter(function(content){
        return App.cfg.templateMap[content.type] === 'cta';
      });

      var images = contentArr.filter(function(content){
        var roughData = content.data.result[0].payload;
        return App.cfg.templateMap[content.type] === 'fullscreenimage' &&
               roughData.display !== 'manual';
      });

      var takeoverCIs = ctas.concat(images);

      if(takeoverCIs.length){
        var filteredObj = resolveSeenContentInstances(takeoverCIs);
        if(filteredObj.notSeen.length){
          console.log('> not seen', filteredObj.notSeen);
          var replace = curRouteName === 'fullscreenimage';
          App.goto(filteredObj.notSeen[0], replace);
          App.store.prop.ciViewed.set(filteredObj.notSeen[0].id, true);
        }
      }
    },
    evaluateNotifications: function(contentArr){
      var curRouteName = App.vm.$route.name;
      if(curRouteName === 'login' || curRouteName === 'intro' || curRouteName === 'splash' || curRouteName === 'seed' || 
      curRouteName === 'tabbedSeed'){
        return;
      }

      var notifications = contentArr.filter(function(content){
        return content.type === 'notification' ;
      });

      if(notifications.length){
        var filteredObj = resolveSeenContentInstances(notifications);
        if(filteredObj.notSeen.length){
          filteredObj.notSeen[0].getData().then(function(json){
            App.evt.emit(App.actions.PUSH, new ContentNotification(filteredObj.notSeen[0].id,json));
            App.store.prop.ciViewed.set(filteredObj.notSeen[0].id, true);
            App.evt.emit(App.actions.VIBRATE,{
              pattern: [400,40,400]
            });   
          });
        }
      }
    },
    syncTrackedViews: function(contentArr){
      var ids = contentArr.map(function(c){
        return c.id;
      });
      App.store.prop.ciViewed.sync(ids);
    },
    startPoll: function(){
      this.stopPoll();
      this.vm.pollEnabled = true;
      this.poll();
    },
    stopPoll: function(){
      this.vm.pollEnabled = false;
      clearTimeout(this.pollTimer);
    },
    poll: function(){
      App.store.getContents(App.store.APIFIRST).then(function(result){
        App.evaluateCTA(result);
        App.evaluateNotifications(result);
        App.syncTrackedViews(result);
        var hash = App.util.Model.generateHash(result);
        if(hash !== App.vm.curContentHash){
          App.evt.emit(App.actions.DATACHANGED);
          App.vm.curContentHash = hash;
        }
      }).catch(function(e){
        console.error('> ',e);
      }).then(function(){
        if(App.vm.pollEnabled){
          App.pollTimer = setTimeout(function(){
            App.poll();
          },App.cfg.POLLINTERVAL);
        }
      });
    },
    startup: function(){
      deferredReady.resolve();
      var routeName = 'seed';
      if(App.settings.theme.mode === Theme.EMBEDDED){
        routeName = 'tabbed';
      } else if(App.settings.theme.mode === Theme.WIDGET){
        routeName = 'widget';
      }

      App.initCTX().then(function(){
        App.router.replace(routeName);
      });
    },
    setCTXProfile: function(profile){
      Flybits.context.Manager.unregisterAll();
      if(App.cfg.ctx){
        App.ctx.interaction = new InteractionPlugin({
          refreshDelay: 999999
        });
        App.ctx.interaction._store.ready.then(function(){
          return Flybits.context.Manager.register(App.ctx.interaction);
        }).then(function(){
          console.log('> registered:', App.ctx.interaction.TYPEID);
        }).catch(function(e){
          console.log('> ctx registration failed ('+App.ctx.interaction.TYPEID+')', e);
        });
      }

      App.ctx.contentAnalytics = new ContentAnalytics({
        refreshDelay: 999999
      });
      Flybits.context.Manager.register(App.ctx.contentAnalytics);
      
      profile.ctxs.forEach(function(ctx){
        var plugin = new DemoPlugin(ctx.ctxID,{
          refreshDelay: App.cfg.CTXREPORTDELAY
        });
        
        if(ctx.ctxID === 'ctx.sdk.location'){
          App.ctx.location = plugin;
          var coords = [];
          if(ctx.values.coordinates){
            coords = ctx.values.coordinates.split(',').map(function(val){
              if(val){
                return +val;
              }
              return 0;
            });
          }
          App.ctx.location.actual = {
            lat: coords[0],
            lng: coords[1]
          };
          App.ctx.location.reset = {
            lat: 1.1,
            lng: 1.1
          };
          ctx.values = App.ctx.location.reset;
        }

        plugin._store.ready.then(function(){
          return Flybits.context.Manager.register(plugin);
        }).then(function(){
          console.log('> registered:', plugin.TYPEID);
          plugin.setState(ctx.values);
          console.log('> state', ctx.values);
        }).catch(function(e){
          console.log('> ctx registration failed ('+ctx.ctxID+')', e);
        });
      });
      App.vm.currentProfile = profile;
    },
    toast: function(msg, msgType){
      msgType = msgType || 'normal';
      var opt = {
        text: msg,
        gravity: 'bottom',
        duration: 3000
      };
      if(msgType === 'error'){
        opt.backgroundColor = '#b20000';
        opt.duration = 7000;
      }

      Toastify(opt).showToast();
    },
  };

  var router = App.router = new VueRouter({
    mode: 'abstract',
    routes: [{
      path: '/',
      name: 'splash',
      component: SplashPage,
      alias: '/splash'
    },{
      path: '/seed',
      name: 'seed',
      component: SeedPage,
      beforeEnter: function(to, from, next){
        App.evt.emit(App.actions.SCREENSAVE, false);
        next();
      },
    },{
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },{
      path: '/cta/:id',
      name: 'cta',
      component: PageCta
    },{
      path: '/image/:id',
      name: 'fullscreenimage',
      component: PageFullscreenimage
    },{
      path: '/event/:id',
      name: 'event',
      component: PageEvent
    },{
      path: '/videos/:id',
      name: 'videos',
      component: PageVideo
    },{
      path: '/web',
      name: 'web',
      component: PageWeb
    },{
      path: '/link/:id/detail',
      name: 'textlink',
      component: PageTextlink
    },{
      path: '/action/:id/detail',
      name: 'buttonlink',
      component: PageButtonlink
    },{
      path: '/infopage/:id',
      name: 'infopage',
      component: PageInfo
    },{
      path: '/infofeedback/:id',
      name: 'infofeedback',
      component: PageInfofeedback
    },{
      path: '/chat/:id',
      name: 'chat',
      component: PageChat
    },,{
      path: '/imagedetail/:id',
      name: 'imagedetail',
      component: PageImagedetail
    },,{
      path: '/selection/:id',
      name: 'selection',
      component: PageSelection
    },{
      path: '/tabbed',
      name: 'tabbed',
      component: Tabbed,
      children: [{
        path: 'seed',
        name: 'tabbedSeed',
        component: SeedPage
      },{
        path: 'dashboard',
        name: 'tabbedDashboard',
        component: Dashboard
      }]
    },{
      path: '/widget',
      name: 'widget',
      component: Widget
    }]
  });
  App.routeTemplateMap = {
    'demo-infopage': 'infopage',
    'demo-infofeedback': 'infofeedback',
    'demo-chat-conversation': 'chat',
    'demo-imagedetail': 'imagedetail',
    'demo-selection-page': 'selection',
    'fullscreen-image': 'fullscreenimage'
  };

  App.vm = new Vue({
    router: router,
    el: '.container',
    data: function(){
      return {
        isLoaded: false,
        isLoading: false,
        isCFGLoaded: false,
        isDebug: false,
        errorText: '',
        sessionUser: null,
        pollEnabled: false,
        currentProfile: null,
        curContentHash: '',
        version: '',
        disableBrand: false,
        hasLocationCTX: false
      };
    },
    computed: {
    },
    watch: {
      currentProfile: {
        deep: true,
        handler: function(newVal, oldVal){
          if(newVal){
            this.hasLocationCTX = this.currentProfile.ctxs.filter(function(ctx){
              return ctx.ctxID === 'ctx.sdk.location';
            })[0];
          } else{
            this.hasLocationCTX = false;
          }
        }
      }
    },
    methods: {
      refreshApp: function(){
        window.location.reload();
      }
    },
    mounted: function(){
      this.isLoaded = true;
      window.App = App;
    },
  });
  
  /**
   * Resusing the Vue event emitter interface but keeping it generic so we can
   * swap it out for our favourite event emitter if we ever need to.
   */
  App.vm.on = App.vm.$on;
  App.vm.off = App.vm.$off;
  App.vm.emit = App.vm.$emit;
  App.evt = App.vm;

  var loaderStack = [];
  var loadStart = 0;
  App.evt.on(App.actions.LOADING,function(bool, noDelay){
    if(bool){
      App.vm.isLoading = true;
      if(loaderStack.length <= 0){
        loadStart = new Date().getTime();
      }
      loaderStack.push(true);
    } else if(!bool && loaderStack.length > 1){
      loaderStack.pop();
    } else if(!bool){
      loaderStack.pop();
      var now = new Date().getTime();
      if(now - loadStart < 300 && !noDelay){
        setTimeout(function(){
          App.vm.isLoading = false;
        },300);
      } else{
        App.vm.isLoading = false;
      }
    }
  });

  App.evt.on(App.actions.VIBRATE, function(opt){
    if('vibrate' in navigator){
      var input = opt? opt.pattern || opt.duration || [200,50,200] : [200,50,200];
      navigator.vibrate(input);
    }
  });

  App.evt.on(App.actions.PUSH, function(notification){
    if(App.notificationManager){
      App.notificationManager.showMessage(notification);
      console.log('> notification sent to manager', notification);
    } else{
      console.log('> notification manager not found', notification);
    }
  });

  return App;
})();

/*************************************************/

App.router.replace('/');
App.checkVersion();

App.initConfig().then(function(){
  App.Screensaver.init({
    stagnantDelay: App.Screensaver.MINUTE * 30
  });

  return App.settings.init();
}).then(function(){
  return App.initSDK();
}).then(function(){
  App.clearSession();
  return App.login();
}).then(function(){
  App.vm.sessionUser = Flybits.Session.user;
  App.startup();
}).catch(function(e){
  console.log('> initialiaation failed', e);
});

App.store = (function(){
  var getModelID = function(model){
    return model.id;
  };

  var Store = {
    cache: {
      contentStore: {},
      contentDataStore: {},
      ciViewed: {},
      ctxPref: {}
    },
    prop: {
      ciViewed: {
        get: function(id){
          return Store.cache.ciViewed[id];
        },
        set: function(id,bool){
          if(bool){
            Store.cache.ciViewed[id] = true;
          } else{
            delete Store.cache.ciViewed[id];
          }

          return this;
        },
        clear: function(){
          Object.keys(Store.cache.ciViewed).forEach(function(key){
            delete Store.cache.ciViewed[key];
          });

          return this;
        },
        sync: function(sourceOfTruthIDArr){
          Object.keys(Store.cache.ciViewed).forEach(function(key){
            if(sourceOfTruthIDArr.indexOf(key) < 0){
              delete Store.cache.ciViewed[key];
            }
          });

          return this;
        }
      },
      ctxPref: {
        get: function(id){
          return Store.cache.ctxPref[id];
        },
        set: function(id, val){
          if(val){
            Store.cache.ctxPref[id] = true;
          } else{
            delete Store.cache.ctxPref[id];
          }

          return this;
        },
        clear: function(){
          Object.keys(Store.cache.ctxPref).forEach(function(key){
            delete Store.cache.ctxPref[key];
          });

          return this;
        }
      }
    },
    flushAll: function(){
      this.cache.contentStore = {};
      this.cache.contentDataStore = {};
      this.prop.ciViewed.clear();
      this.prop.ctxPref.clear();
    },
    getContents: function(){
      var def = new Deferred();
      var id = 'rc-'+App.vm.sessionUser.id;

      var retrievalPromise = getFromNetwork(id);
      retrievalPromise.then(function(networkArr){
        def.resolve(networkArr);
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    getContent: function(id){
      return Promise.resolve(this.cache.contentStore[id]) 
    }
  };

  var getFromNetwork = function(id){
    var def = new Flybits.Deferred();
    
    Flybits.api.Content.getAll().then(function(res){
      return updateMemCache(id, res.result);
    }).then(function(modelArr){
      def.resolve(Store.cache.contentStore[id]);
    }).catch(function(e){
      def.reject(e);
    });

    return def.promise;
  };

  var updateMemCache = function(id, modelArr){
    var curArr = Store.cache.contentStore[id];
    if(!curArr){
      curArr = Store.cache.contentStore[id] = [];
    }

    var curIDs = curArr.map(getModelID);
    var serverIDs = modelArr.map(getModelID);

    var toDelete = App.util.Obj.difference(curIDs, serverIDs);
    var toAdd = App.util.Obj.difference(serverIDs, curIDs);
    var toUpdate = App.util.Obj.intersection(curIDs, serverIDs);
    var updateObjMap = {};

    // delete
    toDelete.forEach(function(delID){
      App.util.Obj.removeObject(curArr,undefined,function(obj){
        return obj.id === delID;
      });
      delete Store.cache.contentStore[delID];
    });

    // add
    modelArr.forEach(function(curObj){
      if(toAdd.indexOf(curObj.id) > -1){
        curArr.push(curObj);
        Store.cache.contentStore[curObj.id] = curObj;
      } else if(toUpdate.indexOf(curObj.id) > -1){
        updateObjMap[curObj.id] = curObj;
      }
    });

    // update
    curArr.forEach(function(curObj){
      if(toUpdate.indexOf(curObj.id) > -1){
        curObj.fromJSON(updateObjMap[curObj.id].toJSON());
        curObj.data = updateObjMap[curObj.id].data;
      }
    });

    updateOrder(curArr,serverIDs);

    return Promise.resolve(curArr);
  };

  var updateOrder = function(arr, ids){
    arr.sort(function(a,b){
      var aIndex = ids.indexOf(a.id);
      var bIndex = ids.indexOf(b.id);
      return aIndex - bIndex;
    });
  };

  return Store;
})();
App.settings = (function(){
  var resolveGroupName = function(prefix){
    var gName = App.cfg.PROJECTID;
    if(App.cfg.hasOwnProperty('variant')){
      gName += '-'+App.cfg.variant;
    }
    if(prefix){
      gName = prefix + gName;
    }
    return gName;
  };

  var getTheme = function(){
    var def = new Flybits.Deferred();
    var groupName = resolveGroupName('theme-');
    var url = App.cfg.SETTINGSHOST + '/models?groupName='+groupName;
    
    Flybits.util.Api.fetch(url, {
      headers: {
        key: App.cfg.SETTINGSKEY
      },
      respType: 'json'
    }).then(function(resp){
      def.resolve(new Theme(resp.body.data[0], groupName));
    }).catch(function(e){
      def.reject(new Flybits.Validation().addError('cannot retrieve theme','',{
        code: Flybits.Validation.type.RETRIEVALERROR
      }));
    });

    return def.promise;
  };

  var getProfiles = function(){
    var def = new Flybits.Deferred();
    var groupName = resolveGroupName('profiles-');
    var url = App.cfg.SETTINGSHOST + '/models?groupName=' + groupName;

    Flybits.util.Api.fetch(url, {
      headers: {
        key: App.cfg.SETTINGSKEY
      },
      respType: 'json'
    }).then(function(resp){
      def.resolve(resp.body.data[0].profiles.map(function(obj){
        return new Profile(obj);
      }));
    }).catch(function(e){
      def.reject(new Flybits.Validation().addError('cannot retrieve profiles', '',{
        code: Flybits.Validation.type.RETRIEVALERROR
      }));
    });

    return def.promise;
  }; 

  var deferred = new Flybits.Deferred();
  var Settings = {
    ready: deferred.promise,
    theme: null,
    profiles: null,
    $head: document.querySelector('head'),
    init: function(){
      var themeFetch = getTheme();
      themeFetch.then(function(theme){
        Settings.theme = theme;
        Settings.inject(theme);
        Settings.preLoadImages(theme);
        App.evt.emit(App.actions.THEMEUPDATED, theme);
      });
      var profilesFetch = getProfiles();
      profilesFetch.then(function(profiles){
        Settings.profiles = profiles;
      });

      var allInit = Promise.settle([themeFetch,profilesFetch]);
      allInit.then(function(result){
        deferred.resolve();
      });

      return allInit;
    },
    inject: function(theme){
      var $existing = this.$head.querySelector('style[data-type=inject]');

      var $inject = document.createElement('style');
      $inject.setAttribute('type','text/css');
      $inject.setAttribute('data-type','inject');
      var styleStr = "";
      /************* PRIMARY COLOR ********/

      if(App.util.Browser.getURLParam('web')){
        var headerBar = 
          ".header-bar{" + 
            "height: 59px;" +
            "line-height: 59px;" +
          "}" +
          ".header-bar .con{" +
            "opacity: 0;" +
          "}" +
          ".header-bar .con:hover{" +
            "opacity: 1;" +
          "}";
        styleStr += headerBar;
        
        var dashHeader = 
          ".dashboard .balance-banner{" +
            "padding-top: 0;"+
          "}"+
          ".dashboard .balance-banner .tab-status{" +
            "background-color: " + theme.primaryColor + ";" +
            "color:" + App.util.Obj.getContrastYIQ(theme.primaryColor) + ";"+
            "margin: 0;" +
            "padding: 0 10px 0 20px;" +
          "}"+
          ".dashboard .balance-banner .tab-status .header{" +
            "line-height: 61px;"+
          "}" +
          ".dashboard .balance-banner .tab-status .profile-icon{" +
            "top: 5px;"+
          "}";
        styleStr += dashHeader;
        
        var contentWrap = 
          ".dashboard .content-wrap{" +
            "top: 59px;" +
          "}";
        styleStr += contentWrap;

        var hideUnecessary = 
          ".dashboard .balance-banner .tab-status .sub-header{" +
            "display:none;"+
          "}";
        styleStr += hideUnecessary;
      }

      if(theme.primaryColor){
        var loadingBar2 = 
          ".loader-bar .bar:nth-child(2){" +
            "background-color:"+theme.primaryColor+";"+
          "}";
        styleStr += loadingBar2;

        var widgetIcon = 
          ".container .shadow-wrap .action-btn{" +
            "background-color:"+theme.primaryColor+";"+
          "}";
        styleStr += widgetIcon;

        var tabbedFooter = 
          ".tabbed .tab-bar .opt{"+
            "background-color:"+theme.primaryColor+";"+
          "}"+
          ".tabbed .tab-bar .opt:hover{"+
            "background-color:"+theme.tertiaryColor+";"+
          "}"+
          ".tabbed .tab-bar .opt.selected{"+
            "background-color:"+theme.secondaryColor+";"+
          "}";
        styleStr += tabbedFooter;
      }
      /************* SECONDARY COLOR ********/
      if(theme.secondaryColor){
        var loadingBar1 = 
          ".loader-bar .bar:nth-child(1){" +
            "background-color:"+theme.secondaryColor+";"+
          "}";
        styleStr += loadingBar1;
      }
      /************* FOREGROUND COLOR ********/
      /************* MIXED COLOR ********/
      if(theme.primaryColor && theme.tertiaryColor){
        var seedSide = 
          ".seed-page:before{"+
            "background:linear-gradient("+theme.primaryColor+","+theme.primaryColor+","+theme.tertiaryColor+");"+
          "}";
        styleStr += seedSide;

        var userIcon = 
          ".seed-page .option-wrap .option .user-icon:before{"+
            "background:linear-gradient("+theme.primaryColor+","+theme.tertiaryColor+");"+
          "}";
        styleStr += userIcon;

        var dashboardUserIcon = 
          ".dashboard .balance-banner .profile-icon:before{"+
            "background:linear-gradient("+theme.primaryColor+","+theme.tertiaryColor+");"+
          "}";
        styleStr += dashboardUserIcon;

        var sidebarUserIcon = 
          ".side-bar .contents .logo-panel .profile-icon:before{"+
            "background:linear-gradient("+theme.primaryColor+","+theme.tertiaryColor+");"+
          "}";
        styleStr += sidebarUserIcon;
      }

      /************* COLOR OVERRIDES **********/
      if(theme.fineGrainColor){
        if(theme.fineGrainColor.widgetBG){
          widgetIcon = 
            ".container .shadow-wrap .action-btn{" +
              "background-color:"+theme.fineGrainColor.widgetBG+";"+
            "}";
          styleStr += widgetIcon;
        }
        if(theme.fineGrainColor.tabbarBG){
          var tabFG = App.util.Obj.getContrastYIQ(theme.fineGrainColor.tabbarBG);
          tabbedFooter = 
            ".tabbed .tab-bar .opt{"+
              "background-color:"+theme.fineGrainColor.tabbarBG+";"+
              "color:"+tabFG+";"+
            "}"+
            ".tabbed .tab-bar .opt:hover{"+
              "background-color:"+App.util.Obj.lighten(theme.fineGrainColor.tabbarBG, 10)+";"+
            "}";
          styleStr += tabbedFooter;
        }
        if(theme.fineGrainColor.tabbarActiveBG){
          var tabActiveFG = App.util.Obj.getContrastYIQ(theme.fineGrainColor.tabbarActiveBG);
          var tabbedActive = 
            ".tabbed .tab-bar .opt.selected{"+
              "background-color:"+theme.fineGrainColor.tabbarActiveBG+";"+
              "color:"+tabActiveFG+";"+
            "}";
          styleStr += tabbedActive;
        }
        
        if(theme.fineGrainColor.pillsBG){
          var pillFG = App.util.Obj.getContrastYIQ(theme.fineGrainColor.pillsBG);
          var pill = 
            ".dashboard .tab-wrapper .tab.selected{"+
              "background-color:"+theme.fineGrainColor.pillsBG+";"+
              "color:"+pillFG+";"+
            "}";
          styleStr += pill;
        }

        if(theme.fineGrainColor.feedBG){
          var feedFG = App.util.Obj.getContrastYIQ(theme.fineGrainColor.feedBG);
          var feedBG = 
            ".tabbed .dashboard .content-wrap,.dashboard .content-wrap{"+
              "background-color:"+theme.fineGrainColor.feedBG+";"+
            "}"+
            ".tab-wrapper,.tab-status,.dashboard .balance-banner .tab-status .sub-header{"+
              "color:"+feedFG+";"+
            "}";  
          styleStr += feedBG;
        }

        if(theme.fineGrainColor.buttonBG){
          var buttonFG = App.util.Obj.getContrastYIQ(theme.fineGrainColor.buttonBG);
          var darkenedBG = App.util.Obj.lighten(theme.fineGrainColor.buttonBG, 16);
          var buttonTheme = 
            ".btn-theme{" +
              "background-color:" + theme.fineGrainColor.buttonBG +";"+
              "color:" + buttonFG +";"+
            "}"+
            ".btn-theme:hover{" +
              "background-color:" + darkenedBG +";"+
            "}"+
            ".card-buttonlink .main-body .button-wrap .button.btn-theme{" +
              "background-color:" + theme.fineGrainColor.buttonBG +";"+
              "color:" + buttonFG +";"+
              "border: 1px solid " + theme.fineGrainColor.buttonBG +";"+ 
            "}"+
            ".card-buttonlink .main-body .button-wrap .button.btn-theme:hover{" +
              "background-color:" + darkenedBG +";"+
            "}"+
            ".card-actionable .cta-btn .btn-text.btn-theme{" +
              "background-color:" + theme.fineGrainColor.buttonBG +";"+
              "color:" + buttonFG +";"+
            "}"+
            ".card-actionable .cta-btn .btn-text.btn-theme:hover{" +
              "background-color:" + darkenedBG +";"+
            "}"+
            ".page-event .section .reg-prompt.btn-theme{" +
              "background-color:" + theme.fineGrainColor.buttonBG +";"+
              "color:" + buttonFG +";"+
            "}"+
            ".page-event .section .reg-prompt.btn-theme:hover{" +
              "background-color:" + darkenedBG +";"+
            "}"+
            ".page-infofeedback .action{" +
              "background-color:" + theme.fineGrainColor.buttonBG + ";"+
              "color:"+ buttonFG +";" +
            "}"+
            ".page-infofeedback .action:hover{" +
              "background-color:" + darkenedBG + ";"+
            "}";


          styleStr += buttonTheme;
        }
      }

      if(theme.tileStyle){
        if(theme.tileStyle.borderColor){
          var rgb = App.util.Obj.hexToRGB(App.util.Obj.darken(theme.tileStyle.borderColor, 100));
          var tileBorderColor = 
            ".card-base{"+
              "border-color:"+theme.tileStyle.borderColor+";"+
              "box-shadow: 0 2px 2px rgba("+rgb.r+','+rgb.g+','+rgb.b+",0.24);"+
            "}"+
            ".card-base:hover{"+
              "box-shadow: 0 2px 5px rgba("+rgb.r+','+rgb.g+','+rgb.b+",0.24);"+
            "}";
          styleStr += tileBorderColor;
        }

        if(theme.tileStyle.borderRadius){
          var tileBorderRadius = 
            ".card-base{"+
              "border-radius:"+theme.tileStyle.borderRadius+"px;"+
            "}";
          styleStr += tileBorderRadius;
        }

        if(theme.tileStyle.hasOwnProperty('enableShadow') && !theme.tileStyle.enableShadow){
          var tileBorderShadow = 
            ".card-base{"+
              "box-shadow: none;"+
              "border-bottom: 1px solid "+theme.tileStyle.borderColor+";"+
            "}"+
            ".card-base:hover{"+
              "box-shadow: none;"+
            "}";
          styleStr += tileBorderShadow;
        }
        
        if(theme.tileStyle.hasOwnProperty('sideMargin')){
          var tileSideMargin = 
            ".card-base{"+
              "margin-left: "+theme.tileStyle.sideMargin+"px;"+
              "margin-right: "+theme.tileStyle.sideMargin+"px;"+
            "}";
          styleStr += tileSideMargin;
        }
      }


      $inject.innerHTML = styleStr;
      this.$head.appendChild($inject);
      if($existing){
        this.$head.removeChild($existing);
      }
    },
    preLoadImages: function(theme){
      if(!theme){
        return Promise.reject();
      } 
      
      var promises = [];
      if(theme.splashURL){
        promises.push(App.util.Browser.loadImage(theme.splashURL));
      }
      if(theme.appscreenURL){
        promises.push(App.util.Browser.loadImage(theme.appscreenURL));
      }
      if(theme.widgetIconURL){
        promises.push(App.util.Browser.loadImage(theme.widgetIconURL));
      }

      return Promise.settle(promises);
    }
  };

  return Settings;
})();
App.Screensaver = (function(){

  var MINUTE =  1000 * 60;
  var HOUR = MINUTE * 60;
  var DAY = HOUR * 24;

  var resetTimer = function(){
    clearTimeout(Screensaver.timer);

    if(Screensaver.isEnabled && !Screensaver.isTimedOut){
      Screensaver.timer = setTimeout(function(){
        Screensaver.timeout();
      }, Screensaver.stagnantDelay);
    }
  };

  var Screensaver = {
    MINUTE: MINUTE,
    HOUR: HOUR,
    DAY: DAY,
    stagnantDelay: MINUTE,
    timer: null,
    isTimedOut: false,
    isEnabled: false,
    init: function(opts){
      opts = opts || {};
      if(opts.hasOwnProperty('stagnantDelay')){
        this.stagnantDelay = opts.stagnantDelay;
      }

      App.evt.on(App.actions.SCREENSAVE, function(bool){
        if(bool){
          Screensaver.startWindowMonitoring();
        } else{
          Screensaver.stopWindowMonitoring();
        }
      });

      App.evt.on(App.actions.LOCKAPP, function(bool){
        if(!bool && Screensaver.isTimedOut && Screensaver.isEnabled){
          App.startPoll();
          Flybits.context.Manager.startAllServices();
          Screensaver.isTimedOut = false;
        }
      });
    },
    timeout: function(){
      console.log('> screensaver detected timeout');
      Screensaver.isTimedOut = true;
      App.stopPoll();
      Flybits.context.Manager.stopAllServices();
      App.evt.emit(App.actions.LOCKAPP, true);
    },
    startWindowMonitoring: function(){
      this.stopWindowMonitoring();
      console.log('> start window monitor');
      this.isEnabled = true;

      this.timer = setTimeout(function(){
        Screensaver.timeout();
      }, this.stagnantDelay);

      window.addEventListener('click', resetTimer);
      window.addEventListener('mousemove', resetTimer);
      window.addEventListener('mousedown', resetTimer);
      window.addEventListener('keydown', resetTimer);
    },
    stopWindowMonitoring: function(){
      console.log('> stop window monitor');
      this.isEnabled = false;
      clearTimeout(this.timer);
      window.removeEventListener('click', resetTimer);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('mousedown', resetTimer);
      window.removeEventListener('keydown', resetTimer);
      this.timer = null;
    }
  };

  return Screensaver;
})();
App.util.Obj = (function(){
  var s4 = function(){
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  };
  
  var Obj = {
    guid:function(tuples){
      var str = 'js';
      if(tuples && tuples > 0){
        for(var i = 0; i < tuples; i++){
          str += str !== 'js'?'-'+s4():s4();
        }
        return str;
      }
      return 'js' + s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
    },
    zero2Pad: function(num){
      return ('0'+num).slice(-2);
    },
    removeObject:function(arr,obj,findCallback){
      var index = arr.indexOf(obj);

      if(findCallback){
        var objs = arr.filter(findCallback);
        if(objs.length > 0){
          index = arr.indexOf(objs[0]);
        }
      }

      if(index >= 0){
        return arr.splice(index,1);
      }
      return arr;
    },
    difference: function(currentSource, sourceOfTruth){
      var diff = [];

      for(var i = 0; i < currentSource.length; i++){
        if(sourceOfTruth.indexOf(currentSource[i]) < 0){
          diff.push(currentSource[i]);
        }
      }
      return diff;
    },
    intersection: function(currentSource, sourceOfTruth){
      var union = [];

      for(var i = 0; i < currentSource.length; i++){
        if(sourceOfTruth.indexOf(currentSource[i]) > -1){
          union.push(currentSource[i]);
        }
      }
      return union;
    },
    toValueObj: function(rootLocaleObj, propKey) {
      var valueObj = {};
      var localeObj = rootLocaleObj.locales || rootLocaleObj.localizations;
      var localeKeys = localeObj?Object.keys(localeObj):[];
      for (var keyIndex = 0; keyIndex < localeKeys.length; keyIndex++) {
        var localeKey = localeKeys[keyIndex];
        var value = localeObj[localeKey][propKey];
        if (value) {
          valueObj[localeKey] = value;
        }
      }
      return valueObj;
    },
    resolveLocalizedValue: function(localeObj,key){
      var localeKeys = Object.keys(localeObj);
      return localeObj[key] || localeObj['en'] || localeObj[localeKeys[0]];
    },
    hash: function(str) {
      var hash = 0, i, chr;
      if (str.length === 0) return hash;
      for (i = 0; i < str.length; i++) {
        chr   = str.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return 'f'+hash;
    },
    replaceAllStr: function(str, search, replacement){
      return str.split(search).join(replacement);
    },
    getContrastYIQ: function(hexcolor){
      if(hexcolor.charAt(0) === '#'){
        hexcolor = hexcolor.substr(1);
      }
      
      var r = parseInt(hexcolor.substr(0,2),16);
      var g = parseInt(hexcolor.substr(2,2),16);
      var b = parseInt(hexcolor.substr(4,2),16);
      var yiq = ((r*299)+(g*587)+(b*114))/1000;
      return (yiq >= 128) ? 'black' : 'white';
    },
    hexToRGB: function(hexStr){
      if(hexStr[0] == "#"){
        hexStr = hexStr.slice(1);
      }
      var num = parseInt(hexStr,16);
      var r = (num >> 16);
      var g = (num & 0x0000FF);
      var b = ((num >> 8) & 0x00FF);

      return {
        r: r,
        g: g,
        b: b
      };
    },
    lightenDarkenColor: function(col, amt) {
      var usePound = false;
      if(col[0] == "#"){
        col = col.slice(1);
        usePound = true;
      }
      
      var num = parseInt(col,16);
  
      var r = (num >> 16) + amt;
      if(r > 255){
        r = 255;
      } else if(r < 0){
        r = 0;
      }
  
      var b = ((num >> 8) & 0x00FF) + amt;
      if(b > 255){
        b = 255;
      } else if(b < 0){
        b = 0;
      }
  
      var g = (num & 0x0000FF) + amt;
      if(g > 255){
        g = 255;
      } else if(g < 0){
        g = 0;
      }
  
      return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
    },
    darken: function(hexStr, percent){
      return this.lightenDarkenColor(hexStr, -percent);
    },
    lighten: function(hexStr, percent){
      return this.lightenDarkenColor(hexStr, percent);
    },
    randomInt:function(min,max){
      return Math.floor(Math.random()*(max-min+1)+min);
    },
  };

  Obj.extend = (function(){
    function isMergeableObject(val) {
      var nonNullObject = val && typeof val === 'object';

      return nonNullObject && Object.prototype.toString.call(val) !== '[object RegExp]' && Object.prototype.toString.call(val) !== '[object Date]';
    }

    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }

    function cloneIfNecessary(value, optionsArgument) {
      var clone = optionsArgument && optionsArgument.clone === true;
      return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value;
    }

    function defaultArrayMerge(target, source, optionsArgument) {
      var destination = target.slice();
      source.forEach(function (e, i) {
        if (typeof destination[i] === 'undefined') {
          destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
          destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
          destination.push(cloneIfNecessary(e, optionsArgument));
        }
      });
      return destination;
    }

    function mergeObject(target, source, optionsArgument) {
      var destination = {};
      if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
          destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
      }
      Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
          destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
          destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
      });
      return destination;
    }

    function deepmerge(target, source, optionsArgument) {
      var array = Array.isArray(source);
      var options = optionsArgument || { arrayMerge: defaultArrayMerge };
      var arrayMerge = options.arrayMerge || defaultArrayMerge;

      if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument);
      } else {
        return mergeObject(target, source, optionsArgument);
      }
    }

    deepmerge.all = function deepmergeAll(array, optionsArgument) {
      if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements');
      }

      // we are sure there are at least 2 values, so it is safe to have no initial value
      return array.reduce(function (prev, next) {
        return deepmerge(prev, next, optionsArgument);
      });
    };

    return deepmerge;
  })();

  return Obj;
})();
App.util.Api = (function(){
  var defaultAjaxOpts = {
    method: 'GET',
    headers: {}
  };

  var Api = {
    fetch: function(url,opts){
      opts = opts || {};
      opts.respType = opts.respType || 'json';
      var def = new Deferred();
      
      var ajaxOpts = ObjUtil.extend({},defaultAjaxOpts);
      var isJSON = opts.respType === 'json';
      delete opts.respType;
      ObjUtil.extend(ajaxOpts,opts);

      fetch(url,ajaxOpts).then(this.checkResult).then(this.getResultBody)
        .then(function(respObj){
          if(isJSON){
            try{
              respObj.body = api.parseResponse(respObj.body);
              def.resolve(respObj);
            } catch(e){
              def.reject(new Validation().addError("Request Failed","Unexpected server response.",{
                code: Validation.type.MALFORMED,
              }));
            }
          } else{
            def.resolve(respObj);
          }
        }).catch(function(resp){
          api.getResultBody(resp).then(function(resultObj){
            var parsedResp = api.parseErrorMsg(resultObj.body);
            def.reject(new Validation().addError('Request error',parsedResp,{
              serverCode: resp.status
            }));
          });
        });

      return def.promise;
    },
    checkResult: function(resp){
      if(resp.status >= 200 && resp.status < 300){
        return resp;
      }
      throw resp;
    },
    getResultBody: function(resp){
      var def = new Deferred();
      if(resp && resp.text){
        var respHeaders = {};
        resp.headers.forEach(function(val,key){
          respHeaders[key] = val;
        });
        resp.text().then(function(str){
          def.resolve({
            body: str,
            headers: respHeaders
          });
        }).catch(function(e){
          def.reject(e);
        });
      } else{
        def.resolve({
          body: "",
          headers: {}
        });
      }

      return def.promise;
    },
    getResultJSON: function(resp){
      return resp.json();
    },
    htmlEncode:function(value){
      /*global encodeURIComponent*/
      return encodeURIComponent(value);
    },
    htmlDecode:function(str){
      return str.replace(/&#?(\w+);/g, function(match, dec) {
        if(isNaN(dec)) {
          chars = {quot: 34, amp: 38, lt: 60, gt: 62, nbsp: 160, copy: 169, reg: 174, deg: 176, frasl: 47, trade: 8482, euro: 8364, Agrave: 192, Aacute: 193, Acirc: 194, Atilde: 195, Auml: 196, Aring: 197, AElig: 198, Ccedil: 199, Egrave: 200, Eacute: 201, Ecirc: 202, Euml: 203, Igrave: 204, Iacute: 205, Icirc: 206, Iuml: 207, ETH: 208, Ntilde: 209, Ograve: 210, Oacute: 211, Ocirc: 212, Otilde: 213, Ouml: 214, times: 215, Oslash: 216, Ugrave: 217, Uacute: 218, Ucirc: 219, Uuml: 220, Yacute: 221, THORN: 222, szlig: 223, agrave: 224, aacute: 225, acirc: 226, atilde: 227, auml: 228, aring: 229, aelig: 230, ccedil: 231, egrave: 232, eacute: 233, ecirc: 234, euml: 235, igrave: 236, iacute: 237, icirc: 238, iuml: 239, eth: 240, ntilde: 241, ograve: 242, oacute: 243, ocirc: 244, otilde: 245, ouml: 246, divide: 247, oslash: 248, ugrave: 249, uacute: 250, ucirc: 251, uuml: 252, yacute: 253, thorn: 254, yuml: 255, lsquo: 8216, rsquo: 8217, sbquo: 8218, ldquo: 8220, rdquo: 8221, bdquo: 8222, dagger: 8224, Dagger: 8225, permil: 8240, lsaquo: 8249, rsaquo: 8250, spades: 9824, clubs: 9827, hearts: 9829, diams: 9830, oline: 8254, larr: 8592, uarr: 8593, rarr: 8594, darr: 8595, hellip: 133, ndash: 150, mdash: 151, iexcl: 161, cent: 162, pound: 163, curren: 164, yen: 165, brvbar: 166, brkbar: 166, sect: 167, uml: 168, die: 168, ordf: 170, laquo: 171, not: 172, shy: 173, macr: 175, hibar: 175, plusmn: 177, sup2: 178, sup3: 179, acute: 180, micro: 181, para: 182, middot: 183, cedil: 184, sup1: 185, ordm: 186, raquo: 187, frac14: 188, frac12: 189, frac34: 190, iquest: 191, Alpha: 913, alpha: 945, Beta: 914, beta: 946, Gamma: 915, gamma: 947, Delta: 916, delta: 948, Epsilon: 917, epsilon: 949, Zeta: 918, zeta: 950, Eta: 919, eta: 951, Theta: 920, theta: 952, Iota: 921, iota: 953, Kappa: 922, kappa: 954, Lambda: 923, lambda: 955, Mu: 924, mu: 956, Nu: 925, nu: 957, Xi: 926, xi: 958, Omicron: 927, omicron: 959, Pi: 928, pi: 960, Rho: 929, rho: 961, Sigma: 931, sigma: 963, Tau: 932, tau: 964, Upsilon: 933, upsilon: 965, Phi: 934, phi: 966, Chi: 935, chi: 967, Psi: 936, psi: 968, Omega: 937, omega: 969}
          if (chars[dec] !== undefined){
            dec = chars[dec];
          }
        }
        return String.fromCharCode(dec);
      });
    },
    base64Decode: function(str){
      return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    },
    parseResponse: function(rawResponse){
      return JSON.parse(rawResponse,function(key,val){
        if(typeof val === "string"){
          return api.htmlDecode(val);
        }
        return val;
      });
    },
    parseErrorMsg: function(rawResponse){
      try{
        var resp = this.parseResponse(rawResponse);
      } catch(e){
        return "Malformed server response";
      }
      var msg = null;

      if(resp){
        if(resp.error){
          resp = resp.error;
        }
        
        return resp.messageJSON || resp.exceptionMessage || resp.message || "Unexpected error has occurred";
      }

      return msg;
    },
    parseYoutubeID: function(url){
      url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      return undefined !== url[2]?url[2].split(/[^0-9a-z_\-]/i)[0]:url[0];
    }
  };

  return Api;
})();
App.util.Model = (function(){
  var Model = {
    resolveTopicParam: function(content){
      if(content.labels && content.labels.length){
        return content.labels[0];
      }

      return content.id;
    },
    generateHash: function(contentArr){
      var ids = contentArr.map(function(c){
        return c.id;
      });
      return App.util.Obj.hash(ids.join(','));
    }
  };

  return Model;
})();
App.util.Browser = (function(){
  Date.prototype.monthNames = [
    "January", "February", "March",
    "April", "May", "June",
    "July", "August", "September",
    "October", "November", "December"
  ];
  Date.prototype.dayNames = [
    "Sunday", "Monday", "Tuesday",
    "Wednesday", "Thursday", "Friday", "Saturday"
  ];
  Date.prototype.getMonthName = function() {
    return this.monthNames[this.getMonth()];
  };
  Date.prototype.getShortMonthName = function () {
    return this.getMonthName().substr(0, 3);
  };
  Date.prototype.getDayName = function(){
    return this.dayNames[this.getDay()];
  };
  Date.prototype.getShortDayName = function(){
    return this.getDayName().substr(0,3);
  };
  
  return {
    getCookie: function(key) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + key + "=");
      if (parts.length == 2) {
        return parts.pop().split(";").shift();
      } else{
        return null;
      }
    },
    setCookie: function(key,value,expiryDateObj){
      var expires = "";
      if (expiryDateObj) {
        expires = "; expires=" + expiryDateObj.toGMTString();
      }
      document.cookie = key + "=" + value + expires + "; path=/";
    },
    getURLParam:function(name) {
      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(window.location.href);
      if (results === null)
        return "";
      else
        return results[1];
    },
    loadImage: function(url){
      var def = new Flybits.Deferred();
      if(!url){
        return Promise.reject();
      }

      var $body = document.querySelector('body');
      var $img = document.createElement('img');
      $img.style.position = 'absolute';
      $img.style.opacity = 0;
      $img.style.width = '1px';
      $img.style.height = '1px';
      $img.setAttribute('src', url);
      $body.appendChild($img);
      $img.onload = function(){
        $body.removeChild($img);
        def.resolve();
      };

      return def.promise;
    }
  };
})();
})(window, document);